<template>
  <div class="w-full">
    <section
      class="block md:hidden fixed inset-x-0 bottom-0 z-50 bg-white shadow-lg"
    >
      <div v-if="classroom?.is_purchased" class="p-4">
        <button
          @click="$router.push('/classroom/' + code + '/activity')"
          class="w-full rounded-full py-2 bg-[#00446F] border border-[#00446F] text-white font-solusi text-base font-semibold outline-none focus:outline-none"
        >
          Lanjutkan
        </button>
      </div>
      <p v-else-if="salesClosed" class="p-4 text-center">
        Pembelian baru dihentikan. <router-link to="/informasi-layanan" class="underline">Informasi layanan</router-link>
      </p>
      <div
        v-else-if="classroom?.must_voucher"
        class="block md:flex w-full items-center justify-center p-4"
      >
        <p class="font-desain text-[#212121] font-semibold text-xl mr-3 mb-3">
          Tukarkan Vouchermu!
        </p>
        <form @submit.prevent="redeemVoucher" class="flex justify-between">
          <input
            type="text"
            required
            v-model="voucher"
            placeholder="Masukkan kode voucher disini"
            class="border border-gray-300 w-full md:w-80 p-2 rounded-md font-solusi text-[#212121] text-sm focus:outline-none focus:ring focus:border-blue-400 font-semibold"
          />
          <button
            type="submit"
            @click="redeemVoucher()"
            class="bg-[#00446F] rounded-full px-4 py-2 ml-2 outline-none focus:outline-none flex items-center"
            :disabled="loadingVoucher"
            :class="loadingVoucher ? 'cursor-wait' : 'cursor-pointer'"
          >
            <div
              v-if="!loadingVoucher"
              class="text-white font-solusi font-semibold text-sm"
            >
              Tukarkan
            </div>
            <div v-else class="px-3">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="spinner"
                class="w-5 h-5 animate-spin"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="#ffffff"
                  d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                ></path>
              </svg>
            </div>
          </button>
        </form>
      </div>
      <div v-else class="grid grid-cols-2 gap-3 p-4">
        <button
          @click="buyNow()"
          class="w-full rounded-full py-2 bg-white border border-[#009DFF] text-[#009DFF] font-solusi text-base font-semibold outline-none focus:outline-none"
        >
          Beli Sekarang
        </button>
        <button
          v-if="!isExistOnCart"
          @click="addToCart(code)"
          class="w-full rounded-full py-2 bg-[#00446F] border border-[#00446F] text-white font-solusi text-base font-semibold outline-none focus:outline-none flex items-center justify-center"
        >
          <svg
            class="mr-1 w-5 h-5"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.6427 11.1903H11.6903V17.1427C11.6903 17.7975 11.1546 18.3332 10.4998 18.3332C9.84508 18.3332 9.30936 17.7975 9.30936 17.1427V11.1903H3.35698C2.70222 11.1903 2.1665 10.6546 2.1665 9.99984C2.1665 9.34508 2.70222 8.80936 3.35698 8.80936H9.30936V2.85698C9.30936 2.20222 9.84508 1.6665 10.4998 1.6665C11.1546 1.6665 11.6903 2.20222 11.6903 2.85698V8.80936H17.6427C18.2975 8.80936 18.8332 9.34508 18.8332 9.99984C18.8332 10.6546 18.2975 11.1903 17.6427 11.1903Z"
              fill="white"
            />
          </svg>
          Keranjang
        </button>
        <button
          v-else
          @click="$router.push('/cart')"
          class="w-full rounded-full py-2 bg-[#00446F] border border-[#00446F] text-white font-solusi text-base font-semibold outline-none focus:outline-none"
        >
          Ke Keranjang
        </button>
      </div>
    </section>
    <div class="my-5 max-w-6xl mx-auto ">
      <div class="flex items-start px-3 md:px-6">
        <router-link
          to="/"
          class="font-solusi text-[#2097F6] hover:font-semibold flex items-center text-xs flex-shrink-0"
        >
          Beranda
          <svg
            class="mx-2 w-2.5 h-2.5"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.19918 5.99997L3.2369 2.2958C2.94112 2.01904 2.91929 1.54782 3.18841 1.24363C3.45753 0.939448 3.91574 0.917001 4.21153 1.19376L8.76302 5.44898C9.07899 5.74485 9.07899 6.25516 8.76302 6.55102L4.21153 10.8062C3.91574 11.083 3.45753 11.0606 3.18841 10.7564C2.9193 10.4522 2.94112 9.98096 3.2369 9.7042L7.19918 5.99997Z"
              fill="#2097F7"
            />
          </svg>
        </router-link>
        <router-link
          :to="'/category?q=' + classroom?.category?.slug"
          class="font-solusi text-[#2097F6] hover:font-semibold flex items-center text-xs flex-shrink-0"
        >
          {{ classroom?.category?.name }}
          <svg
            class="mx-2 w-2.5 h-2.5"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.19918 5.99997L3.2369 2.2958C2.94112 2.01904 2.91929 1.54782 3.18841 1.24363C3.45753 0.939448 3.91574 0.917001 4.21153 1.19376L8.76302 5.44898C9.07899 5.74485 9.07899 6.25516 8.76302 6.55102L4.21153 10.8062C3.91574 11.083 3.45753 11.0606 3.18841 10.7564C2.9193 10.4522 2.94112 9.98096 3.2369 9.7042L7.19918 5.99997Z"
              fill="#2097F7"
            />
          </svg>
        </router-link>
        <div
          class="font-solusi flex items-center text-[#212121] text-xs truncate"
        >
          {{ classroom?.name }}
        </div>
      </div>
    </div>
    <div class="min-h-60 w-full bg-gradient-to-b from-[#00446F] to-[#088BD5]">
      <div
        class="max-w-6xl mx-auto px-5 md:px-6 flex flex-row justify-between h-full"
        :class="classroom?.tag?.length ? 'py-6' : 'py-10'"
      >
        <div class="w-full md:w-[65%] flex flex-col justify-between">
          <div v-if="classroom?.tag?.length" class="flex flex-row mb-3">
            <button
              v-for="(tag, i) in classroom.tag"
              :key="i"
              class="px-2.5 py-1 font-solusi text-[#383838] font-semibold bg-[#DEEBFF] text-2xs outline-none focus:outline-none mr-2 rounded-full uppercase"
            >
              {{ tag.name }}
            </button>
            <!-- <button
              class="px-2.5 py-1 font-solusi text-[#383838] font-semibold bg-[#FFFAF1] text-2xs outline-none focus:outline-none mr-2 rounded-full"
            >
              PRA KERJA
            </button> -->
          </div>
          <p
            class="text-white font-desain text-2xl font-semibold mb-3 text-left"
          >
            {{ classroom?.name }}
          </p>
          <p
            v-if="classroom?.mentor"
            class="text-white font-solusi text-sm mb-5 text-left"
          >
            Oleh: {{ classroom?.mentor[0]?.name }}
          </p>
          <div class="flex flex-col md:flex-row items-start md:items-center">
            <div class="flex items-center">
              <span class="font-solusi text-sm text-white mr-2">Rating:</span>
              <svg
                v-for="rating in 5"
                :key="rating"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.04894 3.42705C7.3483 2.50574 8.6517 2.50574 8.95106 3.42705L9.5716 5.33688C9.70547 5.7489 10.0894 6.02786 10.5227 6.02786H12.5308C13.4995 6.02786 13.9023 7.26748 13.1186 7.83688L11.494 9.01722C11.1435 9.27187 10.9968 9.72323 11.1307 10.1353L11.7512 12.0451C12.0506 12.9664 10.9961 13.7325 10.2124 13.1631L8.58778 11.9828C8.2373 11.7281 7.7627 11.7281 7.41221 11.9828L5.78761 13.1631C5.0039 13.7325 3.94942 12.9664 4.24878 12.0451L4.86932 10.1353C5.00319 9.72323 4.85653 9.27186 4.50604 9.01722L2.88144 7.83688C2.09773 7.26748 2.50051 6.02786 3.46923 6.02786H5.47735C5.91057 6.02786 6.29453 5.7489 6.4284 5.33688L7.04894 3.42705Z"
                  fill="#FFC200"
                />
              </svg>

              <div class="font-solusi text-sm text-white font-semibold ml-2">
                {{ classroom?.rating }}
              </div>
              <div class="font-solusi text-sm text-white ml-1">
                ({{ classroom?.rating_count }} Rating)
              </div>
            </div>
            <svg
              v-if="classroom?.category"
              class="hidden md:block mx-1 w-1.5 h-1.5"
              width="6"
              height="7"
              viewBox="0 0 6 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="3" cy="3.5" r="3" fill="white" />
            </svg>
            <div
              v-if="classroom?.category"
              class="font-solusi text-white text-sm"
            >
              Kategori: {{ classroom?.category?.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="max-w-6xl px-0 md:px-6 mx-auto w-full flex flex-col md:flex-row"
    >
      <div class="w-full md:w-[67%] mt-5 md:mt-0 order-2 md:order-1">
        <div class="w-full pl-4 md:pl-0 pr-4 md:pr-5 py-3">
          <p class="font-desain font-semibold text-xl text-[#212121]">
            Deskripsi Kelas
          </p>
          <div class="mt-3 p-3 w-full flex flex-col rounded-md bg-white">
            <div
              v-html="classroom?.description"
              class="font-solusi text-base origin-top transition-all duration-300 text-[#383838]"
              :class="
                showDescription
                  ? ''
                  : 'max-h-80 overflow-hidden gradient-mask-t-0'
              "
            ></div>
            <button
              class="flex justify-end text-right item-center outline-none focus:outline-none font-solusi font-semibold text-[#2097F6] text-sm"
              @click="toggleDescription()"
            >
              {{ showDescription ? 'Sembunyikan' : 'Selengkapnya' }}
              <svg
                class="self-center ml-2"
                :class="showDescription ? 'rotate-180' : 'rotate-0'"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.99972 9.59891L12.9386 4.31587C13.3076 3.92149 13.9359 3.89239 14.3415 4.25122C14.7471 4.61004 14.777 5.22099 14.408 5.61537L8.73436 11.684C8.33988 12.1053 7.65947 12.1053 7.26498 11.684L1.59136 5.61537C1.22235 5.22099 1.25227 4.61004 1.65785 4.25122C2.06343 3.8924 2.69172 3.9215 3.06073 4.31587L7.99972 9.59891Z"
                  fill="#2097F7"
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          v-if="classroom?.mentor"
          class="w-full pl-4 md:pl-0 pr-4 md:pr-5 py-3"
        >
          <p class="font-desain font-semibold text-xl text-[#212121]">
            Tentang Mentor
          </p>
          <div
            class="overflow-hidden rounded-lg mt-3"
            :class="showMentor ? 'bg-white' : ''"
          >
            <div
              class="flex justify-between items-center p-3 cursor-pointer select-none bg-white hover:bg-blue-50 rounded-lg shadow"
              @click="toggleMentor()"
            >
              <div class="flex-auto flex items-center">
                <img
                  :src="classroom?.mentor[0]?.photo"
                  class="h-12 w-12 rounded-full"
                  alt=""
                />
                <div class="flex flex-col w-full ml-2 truncate">
                  <p
                    class="font-solusi text-base text-[#383838] font-semibold text-left mb-1"
                  >
                    {{ classroom?.mentor[0]?.name }}
                  </p>
                  <p class="font-solusi text-sm text-[#383838] text-left">
                    {{ classroom?.mentor[0]?.attribution }}
                  </p>
                </div>
              </div>
              <svg
                v-if="showMentor && classroom?.mentor[0]?.description != ''"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.7144 8.95213H8.95254H8.66683C8.3335 8.95213 8.52397 8.95213 8.00016 8.95213C7.47635 8.95213 7.75365 8.95213 7.3335 8.95213H7.04778H2.28588C1.76207 8.95213 1.3335 8.52356 1.3335 7.99975C1.3335 7.47594 1.76207 7.04737 2.28588 7.04737H7.04778L7.3335 7.04748C7.66683 7.04751 7.47635 7.04753 8.00016 7.04753C8.52397 7.04753 8.46906 7.04734 8.66683 7.04737H8.95254H13.7144C14.2383 7.04737 14.6668 7.47594 14.6668 7.99975C14.6668 8.52356 14.2383 8.95213 13.7144 8.95213Z"
                  fill="#2097F7"
                />
              </svg>
              <svg
                v-else-if="
                  !showMentor && classroom?.mentor[0]?.description != ''
                "
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.7144 8.95254H8.95254V13.7144C8.95254 14.2383 8.52397 14.6668 8.00016 14.6668C7.47635 14.6668 7.04778 14.2383 7.04778 13.7144V8.95254H2.28588C1.76207 8.95254 1.3335 8.52397 1.3335 8.00016C1.3335 7.47635 1.76207 7.04778 2.28588 7.04778H7.04778V2.28588C7.04778 1.76207 7.47635 1.3335 8.00016 1.3335C8.52397 1.3335 8.95254 1.76207 8.95254 2.28588V7.04778H13.7144C14.2383 7.04778 14.6668 7.47635 14.6668 8.00016C14.6668 8.52397 14.2383 8.95254 13.7144 8.95254Z"
                  fill="#2097F7"
                />
              </svg>
            </div>
            <transition name="collapse">
              <div v-if="showMentor">
                <div
                  class="m-3 p-3 bg-[#F5F7FD] rounded-md font-solusi text-sm text-[#383838]"
                >
                  {{ classroom?.mentor[0]?.description }}
                </div>
              </div>
            </transition>
          </div>
        </div>

        <div class="w-full pl-4 md:pl-0 pr-4 md:pr-5 py-3">
          <p class="font-desain font-semibold text-xl text-[#212121] mb-3">
            Materi Kelas
          </p>
          <div class="rounded-md shadow divide-y divide-gray-300 p-2 bg-white">
            <div
              class="flex pb-1 items-center justify-end border-b border-gray-300"
            >
              <span
                class="font-solusi text-lg font-semibold text-[#383838] text-right"
              >
                {{ classroom?.material?.length }} Topik
              </span>
              <svg
                width="6"
                height="7"
                viewBox="0 0 6 7"
                class="mx-1 w-1 h-1"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="3" cy="3.5" r="3" fill="#333333" />
              </svg>
              <span
                class="font-solusi text-lg font-semibold text-[#383838] text-right"
              >
                {{ totalMaterial }} Materi
              </span>
              <svg
                v-if="classroom.exam"
                width="6"
                height="7"
                viewBox="0 0 6 7"
                class="mx-1 w-1 h-1"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="3" cy="3.5" r="3" fill="#333333" />
              </svg>
              <span
                v-if="classroom.exam"
                class="font-solusi text-lg font-semibold text-[#383838] text-right"
              >
                {{ classroom.exam?.length }} Ujian
              </span>
            </div>
            <div
              v-for="(materi, i) in classroom.material"
              :key="i"
              class="bg-white"
            >
              <div :id="materi.id" :class="{ 'is-active': materi.active }">
                <button
                  @click="toggle(materi.id)"
                  class="flex justify-between items-center px-5 py-3 w-full"
                >
                  <div class="flex items-center">
                    <div
                      class="font-solusi text-[#212121] font-semibold text-base"
                    >
                      {{ materi.name }}
                    </div>
                    <!-- <span class="font-solusi text-[#212121] text-sm ml-2">
                      {{ materi.material.length }} Materi
                    </span> -->
                  </div>
                  <div class="flex items-center">
                    <span class="font-solusi text-[#212121] text-base mr-3">
                      {{ materi.material?.length }} Materi
                    </span>
                    <svg
                      v-if="materi.active"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.7144 8.95213H8.95254H8.66683C8.3335 8.95213 8.52397 8.95213 8.00016 8.95213C7.47635 8.95213 7.75365 8.95213 7.3335 8.95213H7.04778H2.28588C1.76207 8.95213 1.3335 8.52356 1.3335 7.99975C1.3335 7.47594 1.76207 7.04737 2.28588 7.04737H7.04778L7.3335 7.04748C7.66683 7.04751 7.47635 7.04753 8.00016 7.04753C8.52397 7.04753 8.46906 7.04734 8.66683 7.04737H8.95254H13.7144C14.2383 7.04737 14.6668 7.47594 14.6668 7.99975C14.6668 8.52356 14.2383 8.95213 13.7144 8.95213Z"
                        fill="#2097F7"
                      />
                    </svg>
                    <svg
                      v-else
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.7144 8.95254H8.95254V13.7144C8.95254 14.2383 8.52397 14.6668 8.00016 14.6668C7.47635 14.6668 7.04778 14.2383 7.04778 13.7144V8.95254H2.28588C1.76207 8.95254 1.3335 8.52397 1.3335 8.00016C1.3335 7.47635 1.76207 7.04778 2.28588 7.04778H7.04778V2.28588C7.04778 1.76207 7.47635 1.3335 8.00016 1.3335C8.52397 1.3335 8.95254 1.76207 8.95254 2.28588V7.04778H13.7144C14.2383 7.04778 14.6668 7.47635 14.6668 8.00016C14.6668 8.52397 14.2383 8.95254 13.7144 8.95254Z"
                        fill="#2097F7"
                      />
                    </svg>
                  </div>
                </button>
                <transition name="collapse">
                  <div
                    v-if="materi.active"
                    class="bg-[#F5F7FD] divide-y divide-gray-200"
                  >
                    <div
                      v-for="(sub, i) in materi.material"
                      :key="i"
                      class="px-5 py-3 border-t first:border-gray-200"
                    >
                      <div class="flex items-start">
                        <svg
                          v-if="sub.type == 'video'"
                          class="self-center"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.5283 7.59975L6.83196 5.13607C6.51196 4.92795 6.0957 5.15232 6.0957 5.53607V10.4642C6.0957 10.848 6.52758 11.0724 6.83196 10.8642L10.5283 8.40055C10.8164 8.20806 10.8164 7.7918 10.5283 7.59993V7.59975Z"
                            fill="#212121"
                          />
                          <path
                            d="M8.00039 0.399902C3.80855 0.399902 0.400391 3.80806 0.400391 7.9999C0.400391 12.1917 3.80855 15.5999 8.00039 15.5999C12.1922 15.5999 15.6004 12.1917 15.6004 7.9999C15.6004 3.80806 12.1922 0.399902 8.00039 0.399902ZM8.00039 14.4162C4.46407 14.4162 1.58407 11.5362 1.58407 7.9999C1.58407 4.46358 4.46407 1.58358 8.00039 1.58358C11.5367 1.58358 14.4167 4.46358 14.4167 7.9999C14.4167 11.5362 11.5367 14.4162 8.00039 14.4162Z"
                            fill="#212121"
                          />
                        </svg>
                        <svg
                          v-else-if="sub.type == 'module'"
                          class="self-center"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.8298 5.19262C12.8341 5.15539 12.8341 5.11762 12.8298 5.08038C12.8314 5.06743 12.8314 5.05448 12.8298 5.04153C12.8093 4.99459 12.7817 4.95088 12.7478 4.91203L9.2944 1.45868C9.25555 1.42469 9.21184 1.39717 9.1649 1.37666H9.12605L8.97496 1.3335H4.62802C3.91306 1.3335 3.33301 1.91355 3.33301 2.6285V12.9886C3.33301 13.7035 3.91306 14.2836 4.62802 14.2836H11.5347C12.2497 14.2836 12.8297 13.7035 12.8297 12.9886V5.21852V5.19262H12.8298ZM11.3578 4.78685H9.80809C9.56958 4.78685 9.37642 4.59368 9.37642 4.35518V2.80545L11.3578 4.78685ZM11.5348 13.4202H4.62808C4.38958 13.4202 4.19642 13.2271 4.19642 12.9886V2.6285C4.19642 2.39 4.38958 2.19683 4.62808 2.19683H8.51311V4.35518C8.51311 5.07014 9.09316 5.65019 9.80811 5.65019H11.9665V12.9886C11.9665 13.103 11.9211 13.213 11.8402 13.294C11.7593 13.3749 11.6492 13.4202 11.5348 13.4202L11.5348 13.4202Z"
                            fill="#212121"
                          />
                        </svg>
                        <svg
                          v-else
                          class="self-center"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.45912 0.000109652C2.33702 0.000109652 2.21992 0.047951 2.13424 0.134351C2.04784 0.220037 2 0.337145 2 0.459234V13.4577C2.00143 13.7097 2.20636 13.9132 2.45913 13.9125H3.62659V15.0835C3.6273 15.3349 3.83081 15.5377 4.08144 15.5391H13.3991C13.6504 15.5377 13.8532 15.3349 13.8547 15.0835V2.08146C13.8532 1.83082 13.6504 1.62732 13.3991 1.6266H10.62L9.1284 0.134954C9.04271 0.0485542 8.9256 0 8.80423 0L2.45912 0.000109652ZM2.91398 0.915514H8.34849V3.4253H8.34921C8.34778 3.67736 8.552 3.883 8.80406 3.88372H11.3138V13.0021H2.91383L2.91398 0.915514ZM9.26247 1.56387L10.6691 2.96983L9.26319 2.96911L9.26247 1.56387ZM11.5332 2.54141L12.9405 2.5407V14.6251H4.54053V13.9125H11.773C11.788 13.9125 11.803 13.9118 11.818 13.9097C12.0501 13.8861 12.2272 13.6905 12.2279 13.4577V3.4646C12.2343 3.39033 12.2215 3.31536 12.1922 3.24681C12.1922 3.2461 12.1915 3.24538 12.1915 3.24467C12.18 3.21754 12.165 3.19112 12.1486 3.16613C12.1465 3.16327 12.1443 3.16041 12.1422 3.15756C12.1358 3.14827 12.1286 3.13899 12.1208 3.13042C12.1179 3.12757 12.1158 3.12471 12.1129 3.12185C12.1079 3.11543 12.1022 3.10971 12.0965 3.104L11.5332 2.54141ZM4.13852 4.86566V4.86494C4.01714 4.86423 3.90003 4.91279 3.81364 4.99847C3.72796 5.08487 3.6794 5.20198 3.68011 5.32335V7.40485C3.68011 7.52624 3.72867 7.64263 3.81507 7.72831C3.90075 7.81399 4.01715 7.86183 4.13853 7.86112H6.21637C6.33775 7.86183 6.45486 7.81399 6.54054 7.72831C6.62694 7.64262 6.67549 7.52623 6.67549 7.40485V5.32335C6.6762 5.20197 6.62765 5.08486 6.54125 4.99847C6.45556 4.91279 6.33846 4.86423 6.21637 4.86494L4.13852 4.86566ZM7.5888 5.15555L7.58951 5.15484C7.33674 5.15484 7.13252 5.35977 7.13252 5.61254C7.13252 5.8646 7.33674 6.06953 7.58951 6.06953H9.28322C9.53599 6.06953 9.74021 5.8646 9.74021 5.61254C9.74021 5.35977 9.53599 5.15484 9.28322 5.15484L7.5888 5.15555ZM4.59332 5.78035H5.76078V6.9471L4.59403 6.94638L4.59332 5.78035ZM10.2465 6.65863L10.2472 6.65792C10.2308 6.65792 10.2143 6.65791 10.1972 6.66006H7.58943C7.57443 6.65934 7.56015 6.65934 7.54587 6.66006C7.30524 6.68576 7.12743 6.89499 7.13886 7.13562C7.15028 7.37696 7.34807 7.56762 7.58941 7.57118H10.1972C10.3186 7.57761 10.4371 7.5362 10.5278 7.45479C10.6178 7.37411 10.6727 7.26057 10.6792 7.13918C10.6856 7.01851 10.6442 6.89997 10.5628 6.80929C10.4821 6.71932 10.3686 6.66434 10.2472 6.65791L10.2465 6.65863ZM4.13779 8.53594L4.13851 8.53523C4.01712 8.53451 3.90001 8.58307 3.81362 8.66947C3.72724 8.75587 3.67938 8.87298 3.6801 8.99506V11.0758V11.0751C3.6801 11.1965 3.72865 11.3129 3.81505 11.3986C3.90074 11.4843 4.01713 11.5321 4.13851 11.5314H6.21635C6.33774 11.5321 6.45484 11.4843 6.54052 11.3986C6.62692 11.3129 6.67547 11.1965 6.67547 11.0751V8.99508C6.67619 8.87298 6.62835 8.75588 6.54195 8.66949C6.45555 8.5831 6.33844 8.53453 6.21635 8.53524L4.13779 8.53594ZM7.58806 8.82655L7.58949 8.82584C7.341 8.83155 7.1425 9.03433 7.1425 9.28283C7.1425 9.53132 7.341 9.73482 7.58949 9.73981H9.2832C9.5317 9.73482 9.7302 9.53132 9.7302 9.28283C9.7302 9.03433 9.5317 8.83154 9.2832 8.82584L7.58806 8.82655ZM4.59259 9.45063H5.76005V10.6174L4.59401 10.6167L4.59259 9.45063ZM7.58806 10.3275L7.58949 10.3268C7.33672 10.3268 7.13179 10.531 7.13179 10.7838C7.13179 11.0365 7.33672 11.2415 7.58949 11.2415H10.1973C10.45 11.2415 10.655 11.0365 10.655 10.7838C10.655 10.531 10.45 10.3268 10.1973 10.3268L7.58806 10.3275Z"
                            fill="#212121"
                          />
                        </svg>
                        <div
                          class="flex-grow flex justify-between items-center"
                        >
                          <span class="font-solusi text-[#383838] text-sm ml-3">
                            {{ sub.data.name }}
                          </span>
                          <span class="font-solusi text-[#383838] text-sm">
                            {{
                              sub.type == 'video'
                                ? sub.data?.duration
                                : sub.type == 'module'
                                ? '1 Dokumen'
                                : sub.data?.display + ' Pertanyaan'
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>

            <div class="bg-white">
              <button
                class="flex justify-between items-center px-5 py-3 w-full"
                @click="openExam = !openExam"
              >
                <div class="flex items-center">
                  <div
                    class="font-solusi text-[#212121] font-semibold text-base"
                  >
                    Ujian
                  </div>
                </div>
                <div class="flex items-center">
                  <svg
                    v-if="openExam"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.7144 8.95213H8.95254H8.66683C8.3335 8.95213 8.52397 8.95213 8.00016 8.95213C7.47635 8.95213 7.75365 8.95213 7.3335 8.95213H7.04778H2.28588C1.76207 8.95213 1.3335 8.52356 1.3335 7.99975C1.3335 7.47594 1.76207 7.04737 2.28588 7.04737H7.04778L7.3335 7.04748C7.66683 7.04751 7.47635 7.04753 8.00016 7.04753C8.52397 7.04753 8.46906 7.04734 8.66683 7.04737H8.95254H13.7144C14.2383 7.04737 14.6668 7.47594 14.6668 7.99975C14.6668 8.52356 14.2383 8.95213 13.7144 8.95213Z"
                      fill="#2097F7"
                    />
                  </svg>
                  <svg
                    v-else
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.7144 8.95254H8.95254V13.7144C8.95254 14.2383 8.52397 14.6668 8.00016 14.6668C7.47635 14.6668 7.04778 14.2383 7.04778 13.7144V8.95254H2.28588C1.76207 8.95254 1.3335 8.52397 1.3335 8.00016C1.3335 7.47635 1.76207 7.04778 2.28588 7.04778H7.04778V2.28588C7.04778 1.76207 7.47635 1.3335 8.00016 1.3335C8.52397 1.3335 8.95254 1.76207 8.95254 2.28588V7.04778H13.7144C14.2383 7.04778 14.6668 7.47635 14.6668 8.00016C14.6668 8.52397 14.2383 8.95254 13.7144 8.95254Z"
                      fill="#2097F7"
                    />
                  </svg>
                </div>
              </button>
              <transition name="collapse" appear>
                <div
                  v-if="openExam"
                  class="bg-[#F5F7FD] divide-y divide-gray-200"
                >
                  <div
                    v-for="(exam, i) in classroom.exam"
                    :key="i"
                    class="px-5 py-3 border-t first:border-gray-200"
                  >
                    <div class="flex items-start">
                      <svg
                        class="self-center"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.45912 0.000109652C2.33702 0.000109652 2.21992 0.047951 2.13424 0.134351C2.04784 0.220037 2 0.337145 2 0.459234V13.4577C2.00143 13.7097 2.20636 13.9132 2.45913 13.9125H3.62659V15.0835C3.6273 15.3349 3.83081 15.5377 4.08144 15.5391H13.3991C13.6504 15.5377 13.8532 15.3349 13.8547 15.0835V2.08146C13.8532 1.83082 13.6504 1.62732 13.3991 1.6266H10.62L9.1284 0.134954C9.04271 0.0485542 8.9256 0 8.80423 0L2.45912 0.000109652ZM2.91398 0.915514H8.34849V3.4253H8.34921C8.34778 3.67736 8.552 3.883 8.80406 3.88372H11.3138V13.0021H2.91383L2.91398 0.915514ZM9.26247 1.56387L10.6691 2.96983L9.26319 2.96911L9.26247 1.56387ZM11.5332 2.54141L12.9405 2.5407V14.6251H4.54053V13.9125H11.773C11.788 13.9125 11.803 13.9118 11.818 13.9097C12.0501 13.8861 12.2272 13.6905 12.2279 13.4577V3.4646C12.2343 3.39033 12.2215 3.31536 12.1922 3.24681C12.1922 3.2461 12.1915 3.24538 12.1915 3.24467C12.18 3.21754 12.165 3.19112 12.1486 3.16613C12.1465 3.16327 12.1443 3.16041 12.1422 3.15756C12.1358 3.14827 12.1286 3.13899 12.1208 3.13042C12.1179 3.12757 12.1158 3.12471 12.1129 3.12185C12.1079 3.11543 12.1022 3.10971 12.0965 3.104L11.5332 2.54141ZM4.13852 4.86566V4.86494C4.01714 4.86423 3.90003 4.91279 3.81364 4.99847C3.72796 5.08487 3.6794 5.20198 3.68011 5.32335V7.40485C3.68011 7.52624 3.72867 7.64263 3.81507 7.72831C3.90075 7.81399 4.01715 7.86183 4.13853 7.86112H6.21637C6.33775 7.86183 6.45486 7.81399 6.54054 7.72831C6.62694 7.64262 6.67549 7.52623 6.67549 7.40485V5.32335C6.6762 5.20197 6.62765 5.08486 6.54125 4.99847C6.45556 4.91279 6.33846 4.86423 6.21637 4.86494L4.13852 4.86566ZM7.5888 5.15555L7.58951 5.15484C7.33674 5.15484 7.13252 5.35977 7.13252 5.61254C7.13252 5.8646 7.33674 6.06953 7.58951 6.06953H9.28322C9.53599 6.06953 9.74021 5.8646 9.74021 5.61254C9.74021 5.35977 9.53599 5.15484 9.28322 5.15484L7.5888 5.15555ZM4.59332 5.78035H5.76078V6.9471L4.59403 6.94638L4.59332 5.78035ZM10.2465 6.65863L10.2472 6.65792C10.2308 6.65792 10.2143 6.65791 10.1972 6.66006H7.58943C7.57443 6.65934 7.56015 6.65934 7.54587 6.66006C7.30524 6.68576 7.12743 6.89499 7.13886 7.13562C7.15028 7.37696 7.34807 7.56762 7.58941 7.57118H10.1972C10.3186 7.57761 10.4371 7.5362 10.5278 7.45479C10.6178 7.37411 10.6727 7.26057 10.6792 7.13918C10.6856 7.01851 10.6442 6.89997 10.5628 6.80929C10.4821 6.71932 10.3686 6.66434 10.2472 6.65791L10.2465 6.65863ZM4.13779 8.53594L4.13851 8.53523C4.01712 8.53451 3.90001 8.58307 3.81362 8.66947C3.72724 8.75587 3.67938 8.87298 3.6801 8.99506V11.0758V11.0751C3.6801 11.1965 3.72865 11.3129 3.81505 11.3986C3.90074 11.4843 4.01713 11.5321 4.13851 11.5314H6.21635C6.33774 11.5321 6.45484 11.4843 6.54052 11.3986C6.62692 11.3129 6.67547 11.1965 6.67547 11.0751V8.99508C6.67619 8.87298 6.62835 8.75588 6.54195 8.66949C6.45555 8.5831 6.33844 8.53453 6.21635 8.53524L4.13779 8.53594ZM7.58806 8.82655L7.58949 8.82584C7.341 8.83155 7.1425 9.03433 7.1425 9.28283C7.1425 9.53132 7.341 9.73482 7.58949 9.73981H9.2832C9.5317 9.73482 9.7302 9.53132 9.7302 9.28283C9.7302 9.03433 9.5317 8.83154 9.2832 8.82584L7.58806 8.82655ZM4.59259 9.45063H5.76005V10.6174L4.59401 10.6167L4.59259 9.45063ZM7.58806 10.3275L7.58949 10.3268C7.33672 10.3268 7.13179 10.531 7.13179 10.7838C7.13179 11.0365 7.33672 11.2415 7.58949 11.2415H10.1973C10.45 11.2415 10.655 11.0365 10.655 10.7838C10.655 10.531 10.45 10.3268 10.1973 10.3268L7.58806 10.3275Z"
                          fill="#212121"
                        />
                      </svg>
                      <div class="flex-grow flex justify-between items-center">
                        <span class="font-solusi text-[#383838] text-sm ml-3">
                          {{ exam.name }}
                        </span>
                        <span class="font-solusi text-[#383838] text-sm">
                          {{ exam.question + ' Pertanyaan' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>

        <div class="w-full pl-4 md:pl-0 pr-4 md:pr-5 py-3">
          <p class="font-desain font-semibold text-xl text-[#212121]">
            Konten Tambahan
          </p>
          <div class="overflow-hidden bg-white rounded-md shadow mt-3 w-full">
            <div class="flex items-center p-3">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.47041 3.11595C6.28728 3.11595 5.30292 4.07127 5.30292 5.25344V6.31844H3.60792C2.42479 6.31844 1.44043 7.27937 1.44043 8.47095V14.9058C1.44043 16.0974 2.42481 17.0583 3.60792 17.0583H3.72042V20.3958C3.7176 20.5992 3.84323 20.782 4.03355 20.8523C4.22292 20.9226 4.43761 20.8664 4.56793 20.7108L7.73305 17.0582H16.5305C17.7136 17.0582 18.698 16.0926 18.698 14.9057V13.8407H20.393C21.5761 13.8407 22.5605 12.8807 22.5605 11.7032V5.25321C22.5605 4.07572 21.5761 3.11572 20.393 3.11572L7.47041 3.11595ZM7.47041 4.07595H20.393C21.0576 4.07595 21.6005 4.60656 21.6005 5.25344V11.7034C21.6005 12.3503 21.0576 12.8809 20.393 12.8809H18.698V8.47092C18.698 7.28405 17.7136 6.31841 16.5305 6.31841H6.26304V5.25341C6.26304 4.61122 6.80585 4.07592 7.47053 4.07592L7.47041 4.07595ZM3.60785 7.27851H16.5304C17.1951 7.27851 17.7379 7.80819 17.7379 8.47102V14.9059C17.7379 15.5687 17.1951 16.0984 16.5304 16.0984H7.51553C7.3749 16.0975 7.24085 16.1575 7.14804 16.2634L4.6806 19.106V16.5785C4.6806 16.3141 4.46591 16.0985 4.2006 16.0985H3.60809C2.94341 16.0985 2.4006 15.5641 2.4006 14.906V8.47114C2.4006 7.81301 2.94341 7.27863 3.60809 7.27863L3.60785 7.27851Z"
                  fill="#009DFF"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.94433 10.5063C9.21308 10.5063 8.6084 11.1017 8.6084 11.8273C8.6084 12.552 9.21308 13.1482 9.94433 13.1482C10.6812 13.1482 11.2925 12.5529 11.2925 11.8273C11.2925 11.1026 10.6812 10.5063 9.94433 10.5063ZM9.94433 11.4663C10.1825 11.4663 10.3325 11.6304 10.3325 11.8263C10.3325 12.0223 10.1825 12.1863 9.94433 12.1863C9.72402 12.1863 9.5684 12.0223 9.5684 11.8263C9.5684 11.6304 9.72402 11.4663 9.94433 11.4663Z"
                  fill="#009DFF"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.92723 10.5063C5.19597 10.5063 4.5791 11.0932 4.5791 11.8273C4.5791 12.5604 5.19597 13.1482 5.92723 13.1482C6.65849 13.1482 7.26317 12.5529 7.26317 11.8273C7.26317 11.1026 6.65849 10.5063 5.92723 10.5063ZM5.92723 11.4663C6.14754 11.4663 6.30317 11.6304 6.30317 11.8263C6.30317 12.0223 6.1466 12.1863 5.92723 12.1863C5.70692 12.1863 5.5391 12.0138 5.5391 11.8263C5.5391 11.6388 5.70691 11.4663 5.92723 11.4663Z"
                  fill="#009DFF"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.9675 10.5054C13.2372 10.5054 12.624 11.0951 12.624 11.8272C12.624 12.5594 13.2372 13.1491 13.9675 13.1491C14.6978 13.1491 15.3109 12.5594 15.3109 11.8272C15.3109 11.0951 14.6978 10.5054 13.9675 10.5054ZM13.9675 11.4654C14.1831 11.4654 14.3509 11.6369 14.3509 11.8272C14.3509 12.0176 14.1831 12.1891 13.9675 12.1891C13.7518 12.1891 13.584 12.0176 13.584 11.8272C13.584 11.6369 13.7518 11.4654 13.9675 11.4654Z"
                  fill="#009DFF"
                />
              </svg>
              <span class="font-solusi text-base text-[#212121] ml-2"
                >Tanya Mentor</span
              >
            </div>
          </div>
        </div>

        <!-- <div class="w-full pl-4 md:pl-0 pr-4 md:pr-5 py-3">
          <p class="font-desain font-semibold text-xl text-[#212121]">
            Bonus Tambahan
          </p>
          <div class="overflow-hidden bg-white rounded-md shadow mt-3 w-full">
            <div class="px-3 pt-3">
              <p class="w-full font-solusi text-base text-[#212121]  mb-3">
                Bisa ikutan
                <span class="font-solusi text-base text-[#212121] font-semibold"
                  >Carrer Monitoring</span
                >
                untuk mendapatkan panduan:
              </p>
              <div class="flex items-center flex-wrap">
                <div class="flex items-center mr-4 mb-3">
                  <svg
                    width="24"
                    height="24"
                    class="w-5 h-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#009DFF" />
                    <path
                      d="M9.27464 17.9117C9.54934 18.1935 9.93156 18.3532 10.331 18.3532C10.3349 18.3532 10.339 18.3532 10.3432 18.3532C10.7473 18.3498 11.1317 18.1838 11.4043 17.8943L19.3852 9.41787C19.9263 8.84321 19.8843 7.95201 19.2918 7.42732C18.6992 6.903 17.7802 6.94339 17.2391 7.51786L10.313 14.8737L8.15703 12.6598C7.60568 12.0939 6.68587 12.0687 6.10275 12.6028C5.51925 13.1371 5.49329 14.0287 6.04405 14.5945L9.27464 17.9117Z"
                      fill="white"
                    />
                  </svg>
                  <span class="ml-1 font-solusi text-[#212121]">
                    Membuat CV
                  </span>
                </div>
                <div class="flex items-center mr-4 mb-3">
                  <svg
                    width="24"
                    height="24"
                    class="w-5 h-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#009DFF" />
                    <path
                      d="M9.27464 17.9117C9.54934 18.1935 9.93156 18.3532 10.331 18.3532C10.3349 18.3532 10.339 18.3532 10.3432 18.3532C10.7473 18.3498 11.1317 18.1838 11.4043 17.8943L19.3852 9.41787C19.9263 8.84321 19.8843 7.95201 19.2918 7.42732C18.6992 6.903 17.7802 6.94339 17.2391 7.51786L10.313 14.8737L8.15703 12.6598C7.60568 12.0939 6.68587 12.0687 6.10275 12.6028C5.51925 13.1371 5.49329 14.0287 6.04405 14.5945L9.27464 17.9117Z"
                      fill="white"
                    />
                  </svg>
                  <span class="ml-1 font-solusi text-[#212121]">
                    Menulis surat lamaran
                  </span>
                </div>
                <div class="flex items-center mr-4 mb-3">
                  <svg
                    width="24"
                    height="24"
                    class="w-5 h-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#009DFF" />
                    <path
                      d="M9.27464 17.9117C9.54934 18.1935 9.93156 18.3532 10.331 18.3532C10.3349 18.3532 10.339 18.3532 10.3432 18.3532C10.7473 18.3498 11.1317 18.1838 11.4043 17.8943L19.3852 9.41787C19.9263 8.84321 19.8843 7.95201 19.2918 7.42732C18.6992 6.903 17.7802 6.94339 17.2391 7.51786L10.313 14.8737L8.15703 12.6598C7.60568 12.0939 6.68587 12.0687 6.10275 12.6028C5.51925 13.1371 5.49329 14.0287 6.04405 14.5945L9.27464 17.9117Z"
                      fill="white"
                    />
                  </svg>
                  <span class="ml-1 font-solusi text-[#212121]">
                    Menyusun profil Linkedin
                  </span>
                </div>
                <div class="flex items-center mr-4 mb-3">
                  <svg
                    width="24"
                    height="24"
                    class="w-5 h-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#009DFF" />
                    <path
                      d="M9.27464 17.9117C9.54934 18.1935 9.93156 18.3532 10.331 18.3532C10.3349 18.3532 10.339 18.3532 10.3432 18.3532C10.7473 18.3498 11.1317 18.1838 11.4043 17.8943L19.3852 9.41787C19.9263 8.84321 19.8843 7.95201 19.2918 7.42732C18.6992 6.903 17.7802 6.94339 17.2391 7.51786L10.313 14.8737L8.15703 12.6598C7.60568 12.0939 6.68587 12.0687 6.10275 12.6028C5.51925 13.1371 5.49329 14.0287 6.04405 14.5945L9.27464 17.9117Z"
                      fill="white"
                    />
                  </svg>
                  <span class="ml-1 font-solusi text-[#212121]">
                    Menghadapi interview kerja
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div
          v-if="classroom?.tag?.length"
          class="w-full pl-4 md:pl-0 pr-4 md:pr-5 py-3"
        >
          <p class="font-desain font-semibold text-xl text-[#212121]">
            Tagging
          </p>
          <div class="overflow-hidden w-full p-3 flex flex-wrap items-center">
            <div
              v-for="(tag, i) in classroom?.tag"
              :key="i"
              class="bg-[#DEEBFF] rounded-full mr-2 my-1.5 px-3 py-1 font-solusi text-xs"
            >
              {{ tag.name }}
            </div>
          </div>
        </div> -->

        <div
          v-if="reviews.length"
          class="w-full pl-4 md:pl-0 pr-4 md:pr-5 py-3"
        >
          <p class="font-desain font-semibold text-xl text-[#212121]">
            Rating & Ulasan
          </p>
          <div
            class="overflow-hidden bg-white rounded-md shadow mt-3 p-3 w-full flex flex-col"
          >
            <div class="flex items-center p-3">
              <div
                class="flex flex-row md:flex-col justify-start md:justify-center items-center w-[14rem] flex-grow md:flex-grow-0"
              >
                <div class="flex justify-center items-center">
                  <svg
                    class="w-9 h-9 mr-2"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.0489 2.92705C17.3483 2.00574 18.6517 2.00574 18.9511 2.92705L21.8167 11.7467C21.9506 12.1587 22.3346 12.4377 22.7678 12.4377H32.0413C33.0101 12.4377 33.4128 13.6773 32.6291 14.2467L25.1267 19.6976C24.7762 19.9522 24.6295 20.4036 24.7634 20.8156L27.6291 29.6353C27.9284 30.5566 26.874 31.3227 26.0902 30.7533L18.5878 25.3024C18.2373 25.0478 17.7627 25.0478 17.4122 25.3024L9.90976 30.7533C9.12605 31.3227 8.07157 30.5566 8.37092 29.6353L11.2366 20.8156C11.3705 20.4036 11.2238 19.9522 10.8733 19.6976L3.37088 14.2467C2.58717 13.6773 2.98994 12.4377 3.95867 12.4377H13.2322C13.6654 12.4377 14.0494 12.1587 14.1833 11.7467L17.0489 2.92705Z"
                      fill="#FFC200"
                    />
                  </svg>
                  <span
                    class="font-solusi text-[#212121] text-4xl font-semibold"
                    >{{ classroom?.rating }}</span
                  >
                  <span
                    class="font-solusi text-[#9E9E9E] text-sm font-semibold"
                  >
                    /5
                  </span>
                </div>
                <p
                  class="font-solusi text-[#212121] text-sm text-center ml-5 md:ml-0"
                >
                  (dari {{ classroom?.rating_count }} pengguna)
                </p>
              </div>
              <div class="flex-grow hidden md:flex flex-col w-full pl-2">
                <div class="flex items-center mb-2">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.04894 3.42705C7.3483 2.50574 8.6517 2.50574 8.95106 3.42705L9.5716 5.33688C9.70547 5.7489 10.0894 6.02786 10.5227 6.02786H12.5308C13.4995 6.02786 13.9023 7.26748 13.1186 7.83688L11.494 9.01722C11.1435 9.27187 10.9968 9.72323 11.1307 10.1353L11.7512 12.0451C12.0506 12.9664 10.9961 13.7325 10.2124 13.1631L8.58778 11.9828C8.2373 11.7281 7.7627 11.7281 7.41221 11.9828L5.78761 13.1631C5.0039 13.7325 3.94942 12.9664 4.24878 12.0451L4.86932 10.1353C5.00319 9.72323 4.85653 9.27186 4.50604 9.01722L2.88144 7.83688C2.09773 7.26748 2.50051 6.02786 3.46923 6.02786H5.47735C5.91057 6.02786 6.29453 5.7489 6.4284 5.33688L7.04894 3.42705Z"
                      fill="#FFC200"
                    />
                  </svg>
                  <span
                    class="font-solusi text-[#212121] text-sm font-semibold mr-2 ml-1"
                    >5</span
                  >
                  <div class="relative w-[85%]">
                    <div
                      class="overflow-hidden h-2 text-xs flex rounded bg-[#EEEEEE]"
                    >
                      <div
                        :style="
                          'width: ' +
                            (reviewRating?.five / reviewPage.total) * 100 +
                            '%'
                        "
                        class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-[#FFC200]"
                      ></div>
                    </div>
                  </div>
                  <span
                    class="font-solusi text-[#212121] text-sm font-semibold ml-2"
                    >{{ reviewRating?.five }}</span
                  >
                </div>
                <div class="flex items-center mb-2">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.04894 3.42705C7.3483 2.50574 8.6517 2.50574 8.95106 3.42705L9.5716 5.33688C9.70547 5.7489 10.0894 6.02786 10.5227 6.02786H12.5308C13.4995 6.02786 13.9023 7.26748 13.1186 7.83688L11.494 9.01722C11.1435 9.27187 10.9968 9.72323 11.1307 10.1353L11.7512 12.0451C12.0506 12.9664 10.9961 13.7325 10.2124 13.1631L8.58778 11.9828C8.2373 11.7281 7.7627 11.7281 7.41221 11.9828L5.78761 13.1631C5.0039 13.7325 3.94942 12.9664 4.24878 12.0451L4.86932 10.1353C5.00319 9.72323 4.85653 9.27186 4.50604 9.01722L2.88144 7.83688C2.09773 7.26748 2.50051 6.02786 3.46923 6.02786H5.47735C5.91057 6.02786 6.29453 5.7489 6.4284 5.33688L7.04894 3.42705Z"
                      fill="#FFC200"
                    />
                  </svg>
                  <span
                    class="font-solusi text-[#212121] text-sm font-semibold mr-2 ml-1"
                    >4</span
                  >
                  <div class="relative w-[85%]">
                    <div
                      class="overflow-hidden h-2 text-xs flex rounded bg-[#EEEEEE]"
                    >
                      <div
                        :style="
                          'width: ' +
                            (reviewRating?.four / reviewPage.total) * 100 +
                            '%'
                        "
                        class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-[#FFC200]"
                      ></div>
                    </div>
                  </div>
                  <span
                    class="font-solusi text-[#212121] text-sm font-semibold ml-2"
                    >{{ reviewRating?.four }}</span
                  >
                </div>
                <div class="flex items-center mb-2">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.04894 3.42705C7.3483 2.50574 8.6517 2.50574 8.95106 3.42705L9.5716 5.33688C9.70547 5.7489 10.0894 6.02786 10.5227 6.02786H12.5308C13.4995 6.02786 13.9023 7.26748 13.1186 7.83688L11.494 9.01722C11.1435 9.27187 10.9968 9.72323 11.1307 10.1353L11.7512 12.0451C12.0506 12.9664 10.9961 13.7325 10.2124 13.1631L8.58778 11.9828C8.2373 11.7281 7.7627 11.7281 7.41221 11.9828L5.78761 13.1631C5.0039 13.7325 3.94942 12.9664 4.24878 12.0451L4.86932 10.1353C5.00319 9.72323 4.85653 9.27186 4.50604 9.01722L2.88144 7.83688C2.09773 7.26748 2.50051 6.02786 3.46923 6.02786H5.47735C5.91057 6.02786 6.29453 5.7489 6.4284 5.33688L7.04894 3.42705Z"
                      fill="#FFC200"
                    />
                  </svg>
                  <span
                    class="font-solusi text-[#212121] text-sm font-semibold mr-2 ml-1"
                    >3</span
                  >
                  <div class="relative w-[85%]">
                    <div
                      class="overflow-hidden h-2 text-xs flex rounded bg-[#EEEEEE]"
                    >
                      <div
                        :style="
                          'width: ' +
                            (reviewRating?.three / reviewPage.total) * 100 +
                            '%'
                        "
                        class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-[#FFC200]"
                      ></div>
                    </div>
                  </div>
                  <span
                    class="font-solusi text-[#212121] text-sm font-semibold ml-2"
                    >{{ reviewRating?.three }}</span
                  >
                </div>
                <div class="flex items-center mb-2">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.04894 3.42705C7.3483 2.50574 8.6517 2.50574 8.95106 3.42705L9.5716 5.33688C9.70547 5.7489 10.0894 6.02786 10.5227 6.02786H12.5308C13.4995 6.02786 13.9023 7.26748 13.1186 7.83688L11.494 9.01722C11.1435 9.27187 10.9968 9.72323 11.1307 10.1353L11.7512 12.0451C12.0506 12.9664 10.9961 13.7325 10.2124 13.1631L8.58778 11.9828C8.2373 11.7281 7.7627 11.7281 7.41221 11.9828L5.78761 13.1631C5.0039 13.7325 3.94942 12.9664 4.24878 12.0451L4.86932 10.1353C5.00319 9.72323 4.85653 9.27186 4.50604 9.01722L2.88144 7.83688C2.09773 7.26748 2.50051 6.02786 3.46923 6.02786H5.47735C5.91057 6.02786 6.29453 5.7489 6.4284 5.33688L7.04894 3.42705Z"
                      fill="#FFC200"
                    />
                  </svg>
                  <span
                    class="font-solusi text-[#212121] text-sm font-semibold mr-2 ml-1"
                    >2</span
                  >
                  <div class="relative w-[85%]">
                    <div
                      class="overflow-hidden h-2 text-xs flex rounded bg-[#EEEEEE]"
                    >
                      <div
                        :style="
                          'width: ' +
                            (reviewRating?.two / reviewPage.total) * 100 +
                            '%'
                        "
                        class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-[#FFC200]"
                      ></div>
                    </div>
                  </div>
                  <span
                    class="font-solusi text-[#212121] text-sm font-semibold ml-2"
                    >{{ reviewRating?.two }}</span
                  >
                </div>
                <div class="flex items-center">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.04894 3.42705C7.3483 2.50574 8.6517 2.50574 8.95106 3.42705L9.5716 5.33688C9.70547 5.7489 10.0894 6.02786 10.5227 6.02786H12.5308C13.4995 6.02786 13.9023 7.26748 13.1186 7.83688L11.494 9.01722C11.1435 9.27187 10.9968 9.72323 11.1307 10.1353L11.7512 12.0451C12.0506 12.9664 10.9961 13.7325 10.2124 13.1631L8.58778 11.9828C8.2373 11.7281 7.7627 11.7281 7.41221 11.9828L5.78761 13.1631C5.0039 13.7325 3.94942 12.9664 4.24878 12.0451L4.86932 10.1353C5.00319 9.72323 4.85653 9.27186 4.50604 9.01722L2.88144 7.83688C2.09773 7.26748 2.50051 6.02786 3.46923 6.02786H5.47735C5.91057 6.02786 6.29453 5.7489 6.4284 5.33688L7.04894 3.42705Z"
                      fill="#FFC200"
                    />
                  </svg>
                  <span
                    class="font-solusi text-[#212121] text-sm font-semibold mr-3 ml-1"
                    >1</span
                  >
                  <div class="relative w-[85%]">
                    <div
                      class="overflow-hidden h-2 text-xs flex rounded bg-[#EEEEEE]"
                    >
                      <div
                        :style="
                          'width: ' +
                            (reviewRating?.one / reviewPage.total) * 100 +
                            '%'
                        "
                        class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-[#FFC200]"
                      ></div>
                    </div>
                  </div>
                  <span
                    class="font-solusi text-[#212121] text-sm font-semibold ml-2"
                    >{{ reviewRating?.one }}</span
                  >
                </div>
              </div>
            </div>
            <div v-if="reviews.length" class="p-3">
              <!-- <div
                class="border border-gray-100 rounded-md mb-3 p-3 flex flex-col"
              >
                <div class="flex flex-row items-center mb-2">
                  <img
                    src="https://picsum.photos/200"
                    alt=""
                    class="w-10 h-10 rounded-full"
                  />
                  <div class="ml-3 flex flex-col ">
                    <p class="font-solusi text-[#212121] text-sm font-semibold">
                      Sumini Wardani
                    </p>
                    <div class="flex">
                      <svg
                        v-for="i in 5"
                        :key="i"
                        class="w-4 h-4"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.04894 3.42705C7.3483 2.50574 8.6517 2.50574 8.95106 3.42705L9.5716 5.33688C9.70547 5.7489 10.0894 6.02786 10.5227 6.02786H12.5308C13.4995 6.02786 13.9023 7.26748 13.1186 7.83688L11.494 9.01722C11.1435 9.27187 10.9968 9.72323 11.1307 10.1353L11.7512 12.0451C12.0506 12.9664 10.9961 13.7325 10.2124 13.1631L8.58778 11.9828C8.2373 11.7281 7.7627 11.7281 7.41221 11.9828L5.78761 13.1631C5.0039 13.7325 3.94942 12.9664 4.24878 12.0451L4.86932 10.1353C5.00319 9.72323 4.85653 9.27186 4.50604 9.01722L2.88144 7.83688C2.09773 7.26748 2.50051 6.02786 3.46923 6.02786H5.47735C5.91057 6.02786 6.29453 5.7489 6.4284 5.33688L7.04894 3.42705Z"
                          fill="#FFC200"
                        />
                      </svg>
                      <span class="ml-2 font-solusi text-xs text-[#9E9E9E]"
                        >1 Hari yang lalu</span
                      >
                    </div>
                  </div>
                </div>
                <p class="font-solusi text-sm text-[#383838]">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Mollis in posuere dui sed massa consectetur. Non adipiscing
                  cursus malesuada pellentesque sed quam faucibus dui auctor.
                  Est ultricies non dapibus viverra et augue quis amet odio.
                  Vitae diam at ac tincidunt.
                </p>
              </div> -->
              <div
                v-for="(review, i) in reviews"
                :key="i"
                class="border border-gray-100 rounded-md mb-3 p-3 flex flex-col"
              >
                <div class="flex flex-row items-center mb-2">
                  <div
                    class="w-10 h-10 rounded-full text-center font-solusi capitalize align-middle text-white inline-flex justify-center items-center"
                    :style="'background-color: ' + toHex(review.name)"
                  >
                    {{
                      review.name
                        ? getInitialName(review.name)
                        : getInitialName('aninom')
                    }}
                  </div>
                  <div class="ml-3 flex flex-col ">
                    <p
                      class="font-solusi text-[#212121] text-base font-semibold"
                    >
                      {{ review.name ? review.name : 'Anonim' }}
                    </p>
                    <div class="flex">
                      <div v-for="i in 5" :key="i" class="flex">
                        <svg
                          v-if="parseInt(review.rating) >= i"
                          class="w-4 h-4"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.04894 3.42705C7.3483 2.50574 8.6517 2.50574 8.95106 3.42705L9.5716 5.33688C9.70547 5.7489 10.0894 6.02786 10.5227 6.02786H12.5308C13.4995 6.02786 13.9023 7.26748 13.1186 7.83688L11.494 9.01722C11.1435 9.27187 10.9968 9.72323 11.1307 10.1353L11.7512 12.0451C12.0506 12.9664 10.9961 13.7325 10.2124 13.1631L8.58778 11.9828C8.2373 11.7281 7.7627 11.7281 7.41221 11.9828L5.78761 13.1631C5.0039 13.7325 3.94942 12.9664 4.24878 12.0451L4.86932 10.1353C5.00319 9.72323 4.85653 9.27186 4.50604 9.01722L2.88144 7.83688C2.09773 7.26748 2.50051 6.02786 3.46923 6.02786H5.47735C5.91057 6.02786 6.29453 5.7489 6.4284 5.33688L7.04894 3.42705Z"
                            fill="#FFC200"
                          />
                        </svg>
                        <svg
                          v-else
                          class="w-4 h-4"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.04894 2.92705C7.3483 2.00574 8.6517 2.00574 8.95106 2.92705L9.5716 4.83688C9.70547 5.2489 10.0894 5.52786 10.5227 5.52786H12.5308C13.4995 5.52786 13.9023 6.76748 13.1186 7.33688L11.494 8.51722C11.1435 8.77187 10.9968 9.22323 11.1307 9.63525L11.7512 11.5451C12.0506 12.4664 10.9961 13.2325 10.2124 12.6631L8.58778 11.4828C8.2373 11.2281 7.7627 11.2281 7.41221 11.4828L5.78761 12.6631C5.0039 13.2325 3.94942 12.4664 4.24878 11.5451L4.86932 9.63526C5.00319 9.22323 4.85653 8.77186 4.50604 8.51722L2.88144 7.33688C2.09773 6.76748 2.50051 5.52786 3.46923 5.52786H5.47735C5.91057 5.52786 6.29453 5.2489 6.4284 4.83688L7.04894 2.92705Z"
                            fill="#9E9E9E"
                          />
                        </svg>
                      </div>
                      <!-- <span class="ml-2 font-solusi text-xs text-[#9E9E9E]"
                        >1 Hari yang lalu</span
                      > -->
                    </div>
                  </div>
                </div>
                <p class="font-solusi text-base text-[#383838]">
                  {{ review.content }}
                </p>
                <div v-if="review?.image_rating" class="mt-1">
                  <img
                    @click="openImageRating(review?.image_rating)"
                    :src="review?.image_rating"
                    alt=""
                    class="w-[60px] h-[60px] rounded-md drop-shadow-md hover:drop-shadow-xl duration-200 cursor-pointer"
                  />
                </div>
              </div>

              <Paginator
                :rows="reviewPage.perPage"
                :totalRecords="reviewPage.total"
                :first="reviewPage.from - 1"
                @page="changePageReview($event)"
              ></Paginator>
            </div>
          </div>
        </div>
      </div>

      <div
        class="w-full md:w-[33%] bg-white md:rounded-md p-3 md:-mt-36 md:sticky top-16 self-start order-1 md:order-2 shadow mb-3"
      >
        <div class="relative">
          <img
            :src="classroom?.thumbnail"
            alt=""
            class="w-full mb-3 rounded-md bg-cover border"
          />
          <div
            v-if="classroom?.url_video"
            @click="openVideo()"
            class="absolute top-0 left-0 flex justify-center items-center w-full h-full bg-white bg-opacity-20 cursor-pointer"
          >
            <svg
              class="w-16 h-16"
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40" cy="40" r="40" fill="#F5F6F8" />
              <path
                d="M29.8672 52.615C29.8672 54.7384 31.377 55.6079 33.223 54.5486L55.1493 41.9326C56.9954 40.8709 56.9954 39.1319 55.1493 38.0703L33.223 25.4531C31.3769 24.3914 29.8672 25.2597 29.8672 27.3866V52.615Z"
                fill="#212121"
              />
            </svg>
          </div>
        </div>

        <div class="">
          <div class="flex items-center mb-3 ">
            <span
              class="font-solusi text-[#212121] text-3xl font-semibold mr-2"
            >
              Rp. {{ classroom?.rupiah_price_formatted }}
            </span>
            <span
              v-if="classroom?.normal_price_formatted"
              class="font-solusi text-[#DE1306] text-lg line-through"
            >
              Rp. {{ classroom?.normal_price_formatted }}
            </span>
          </div>
          <div class="flex items-center mb-3">
            <span class="font-solusi text-[#212121] text-2xs"
              >Disc {{ classroom?.discount }}%</span
            >
            <svg
              v-if="classroom?.quota"
              width="6"
              height="7"
              viewBox="0 0 6 7"
              class="mx-1 w-1 h-1"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="3" cy="3.5" r="3" fill="#333333" />
            </svg>
            <svg
              v-if="classroom?.quota"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              class="mr-1 h-3 w-3"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.75324 14.7814C6.19386 14.7814 4.63132 14.7845 3.07196 14.7783C2.15632 14.7751 1.53133 14.3595 1.27196 13.6095C1.0157 12.8689 1.21258 12.0314 1.94383 11.5689C3.11884 10.8282 4.35951 10.1907 5.58751 9.53446C5.71251 9.46884 5.94688 9.53759 6.10314 9.60946C7.23439 10.1063 8.35306 10.1095 9.49066 9.62196C9.68754 9.53759 9.98754 9.52509 10.1688 9.61571C11.2438 10.1626 12.3094 10.7251 13.3531 11.3282C14.2937 11.8719 14.6469 12.7844 14.3187 13.6469C14.0375 14.3844 13.45 14.7719 12.5562 14.7782C10.9562 14.7875 9.35298 14.7844 7.75298 14.7813L7.75324 14.7814Z"
                fill="#219EBC"
              />
              <path
                d="M4.26877 5.37822C4.26564 2.79694 6.08749 0.962537 8.2406 1.24078C9.53123 1.40641 10.3812 2.19703 10.9249 3.33454C11.6906 4.93774 11.3718 6.94702 10.1687 8.15326C9.25617 9.06575 8.15923 9.42513 6.91235 9.05014C5.50297 8.62827 4.74355 7.57513 4.39043 6.19702C4.30918 5.87514 4.29043 5.53764 4.26855 5.37827L4.26877 5.37822Z"
                fill="#219EBC"
              />
            </svg>
            <span
              v-if="classroom?.quota"
              class="font-solusi text-[#212121] text-2xs"
              >{{ classroom?.quota }} Kuota</span
            >
            <span
              v-if="classroom?.available_quota"
              class="font-solusi text-[#212121] text-2xs"
              >(sisa {{ classroom?.available_quota }})</span
            >
            <!-- <svg
              width="6"
              height="7"
              viewBox="0 0 6 7"
              class="mx-1 w-1 h-1"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="3" cy="3.5" r="3" fill="#333333" />
            </svg>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              class="mr-1 h-3 w-3"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.9329 5.48194L13.4039 4.99335C13.4222 4.97497 13.4222 4.95729 13.4399 4.95729C13.6754 4.66738 13.657 4.25163 13.4039 3.98011L12.6254 3.20091C12.3538 2.9294 11.9013 2.9294 11.6298 3.18253L11.6114 3.20091L11.1228 3.70789C10.5614 3.36426 9.92786 3.11041 9.25823 2.96545L9.25893 2.11484H9.62096C10.019 2.11484 10.345 1.78888 10.345 1.3908C10.345 0.992714 10.019 0.666748 9.62096 0.666748H6.34428C5.9462 0.666748 5.62024 0.992714 5.62024 1.3908C5.62024 1.78888 5.9462 2.11484 6.34428 2.11484H6.70631V2.98384C4.02715 3.56294 2 5.95207 2 8.81224C2 12.1065 4.67916 14.7856 7.97339 14.7856C11.2676 14.7856 13.9468 12.1065 13.9468 8.81224C13.9468 7.58122 13.5664 6.42307 12.9328 5.48199L12.9329 5.48194ZM8.15459 8.63118V4.2869C9.34956 4.2869 10.4357 4.77548 11.2318 5.55398C12.0103 6.35014 12.4989 7.43614 12.4989 8.63118H8.15459Z"
                fill="#DE1306"
              />
            </svg>
            <span class="text-solusi text-[#DE1306] text-2xs"
              >5 jam lagi dengan harga ini</span
            > -->
          </div>
          <div class="hidden md:block">
            <button
              v-if="classroom?.is_purchased"
              @click="$router.push('/classroom/' + code + '/activity')"
              class="w-full rounded-full py-2 bg-[#00446F] border border-[#00446F] text-white font-solusi text-base font-semibold mb-3 outline-none focus:outline-none"
            >
              Lanjutkan
            </button>
            <p v-else-if="salesClosed" class="py-3">
              Pembelian baru dihentikan. <router-link to="/informasi-layanan" class="underline">Informasi layanan</router-link>
            </p>
            <div
              v-else-if="classroom?.must_voucher"
              class="flex flex-col w-full items-start justify-center py-3"
            >
              <p
                class="font-desain text-[#212121] font-semibold text-xl mr-3 mb-1"
              >
                Tukarkan Vouchermu!
              </p>
              <form
                @submit.prevent="redeemVoucher"
                class="w-full flex flex-col justify-between space-y-4"
              >
                <input
                  type="text"
                  required
                  v-model="voucher"
                  placeholder="Masukkan kode voucher disini"
                  class="border border-gray-300 w-full p-2 rounded-md font-solusi text-[#212121] text-sm focus:outline-none focus:ring focus:border-blue-400 font-semibold"
                />
                <button
                  type="submit"
                  @click="redeemVoucher()"
                  class="bg-[#00446F] rounded-full px-4 py-2 outline-none focus:outline-none flex items-center justify-center"
                  :disabled="loadingVoucher"
                  :class="loadingVoucher ? 'cursor-wait' : 'cursor-pointer'"
                >
                  <div
                    v-if="!loadingVoucher"
                    class="text-white font-solusi font-semibold text-sm"
                  >
                    Tukarkan
                  </div>
                  <div v-else class="px-3">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="spinner"
                      class="w-5 h-5 animate-spin"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="#ffffff"
                        d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                      ></path>
                    </svg>
                  </div>
                </button>
              </form>
            </div>
            <div v-else>
              <button
                v-if="!isExistOnCart"
                @click="addToCart(code)"
                class="w-full rounded-full py-2 bg-[#00446F] border border-[#00446F] text-white font-solusi text-base font-semibold mb-3 outline-none focus:outline-none"
              >
                Tambah Ke Keranjang
              </button>
              <button
                v-if="isExistOnCart"
                @click="$router.push('/cart')"
                class="w-full rounded-full py-2 bg-[#00446F] border border-[#00446F] text-white font-solusi text-base font-semibold mb-3 outline-none focus:outline-none"
              >
                Ke Keranjang
              </button>
              <button
                @click="buyNow()"
                class="w-full rounded-full py-2 bg-white border border-[#009DFF] text-[#009DFF] font-solusi text-base font-semibold mb-3 outline-none focus:outline-none"
              >
                Beli Sekarang
              </button>
            </div>
          </div>
          <p
            v-if="classroom?.facility.length > 0"
            class="my-3 font-solusi text-[#212121] text-base font-semibold"
          >
            Kelas ini mencakup:
          </p>
          <div
            v-for="(facility, i) in classroom?.facility"
            :key="i"
            class="flex items-center mb-3"
          >
            <!-- <img :src="facility.icon" alt=""> -->
            <div v-html="facility.icon"></div>
            <p class="font-solusi text-sm text-[#383838] ml-2">
              {{ facility.name }}
            </p>
          </div>
          <!-- <div class="flex items-center mb-3">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              class="w-5 h-5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.2451 7.78868C19.2516 7.73284 19.2516 7.67618 19.2451 7.62033C19.2476 7.60091 19.2476 7.58148 19.2451 7.56206C19.2144 7.49164 19.1731 7.42608 19.1221 7.36781L13.9421 2.18778C13.8838 2.13679 13.8183 2.09551 13.7478 2.06475H13.6896L13.4629 2H6.94251C5.87008 2 5 2.87008 5 3.94251V19.4826C5 20.555 5.87008 21.4251 6.94251 21.4251H17.3026C18.375 21.4251 19.2451 20.555 19.2451 19.4826V7.82753V7.78868H19.2451ZM17.0372 7.18003H14.7126C14.3549 7.18003 14.0651 6.89028 14.0651 6.53253V4.20794L17.0372 7.18003ZM17.3027 20.1301H6.94261C6.58486 20.1301 6.29511 19.8404 6.29511 19.4826V3.94251C6.29511 3.58476 6.58486 3.29501 6.94261 3.29501H12.7701V6.53253C12.7701 7.60496 13.6402 8.47504 14.7127 8.47504H17.9502V19.4826C17.9502 19.6542 17.8822 19.8193 17.7608 19.9407C17.6394 20.0621 17.4743 20.1301 17.3027 20.1301L17.3027 20.1301Z"
                fill="#333333"
              />
            </svg>
            <p class="font-solusi text-sm text-[#383838] ml-2">
              18 Dokumen pelatihan
            </p>
          </div>
          <div class="flex items-center mb-3">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              class="w-5 h-5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.3207 8.15175L20.7019 7.53395C20.0429 6.87582 18.975 6.87582 18.316 7.53395L16.8404 9.00956V5.08148C16.8385 3.73616 15.7482 2.64596 14.4029 2.64404H8.82677C8.81552 2.64404 8.8052 2.64967 8.79395 2.64967C8.74989 2.65248 8.70583 2.66092 8.66364 2.67404C8.64583 2.67873 8.62802 2.68435 8.61114 2.69092C8.55302 2.71342 8.49864 2.74623 8.45177 2.78748L2.37305 8.2326C2.33555 8.26729 2.30273 8.30666 2.27648 8.35072C2.26898 8.36197 2.26242 8.37322 2.2568 8.38541L2.25586 8.38447C2.23617 8.42197 2.22023 8.46135 2.20805 8.5026C2.20617 8.5101 2.20242 8.5176 2.20055 8.5251C2.19117 8.56635 2.18555 8.60854 2.18555 8.65166V18.9191C2.18742 20.2644 3.27774 21.3546 4.62299 21.3565H14.403C15.7483 21.3547 16.8385 20.2643 16.8404 18.9191V15.0191L21.3207 10.5388C21.9779 9.87878 21.9779 8.81191 21.3207 8.15191L21.3207 8.15175ZM19.9069 8.32894L20.5247 8.94675V8.94769C20.7441 9.16706 20.7441 9.5233 20.5247 9.74362L20.1375 10.1308L18.7238 8.71707L19.1119 8.32894H19.111C19.3313 8.1105 19.6866 8.1105 19.9069 8.32894V8.32894ZM13.4644 16.8031L11.5687 17.2831L12.0506 15.3894L17.9277 9.51224L19.3415 10.926L13.4644 16.8031ZM7.46052 5.18566L8.26397 4.46566V6.7766C8.26303 7.50128 7.67616 8.08815 6.95145 8.08911H4.21857L7.46052 5.18566ZM15.7153 18.9192C15.7144 19.6439 15.1275 20.2307 14.4028 20.2317H4.62281C3.89813 20.2308 3.31125 19.6439 3.31029 18.9192V9.21406H6.95157C8.29783 9.21219 9.38805 8.12187 9.38901 6.77662V3.76918H14.4029C15.1275 3.77012 15.7144 4.35699 15.7154 5.08169V10.1349L11.146 14.7043C11.0748 14.7755 11.0241 14.8646 10.9988 14.963L10.246 17.9217C10.1963 18.1139 10.2526 18.3173 10.3923 18.458C10.5329 18.5986 10.7363 18.6549 10.9285 18.6061L13.8911 17.8561C13.9895 17.8317 14.0795 17.7802 14.1508 17.7089L15.7154 16.1442L15.7153 18.9192Z"
                fill="#333333"
              />
            </svg>
            <p class="font-solusi text-sm text-[#383838] ml-2">
              4 Ujian evaluasi
            </p>
          </div>
          <div class="flex items-center mb-3">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              class="w-5 h-5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.06485 19.0553H15.2648L14.2092 22.1275C14.1614 22.3197 14.2092 22.5119 14.3536 22.6553C14.498 22.7997 14.6892 22.8475 14.8814 22.751L17.7605 21.5997L20.6882 22.7519C20.8804 22.7997 21.0726 22.7997 21.216 22.6563C21.3604 22.5119 21.4082 22.3207 21.3604 22.1285L20.3048 19.0562H22.0326C22.897 19.0562 23.617 18.3362 23.617 17.4719L23.616 2.78409C23.616 1.91971 22.896 1.19971 22.0317 1.19971H2.06485C1.20047 1.19971 0.480469 1.91971 0.480469 2.78409V17.5196C0.480469 18.384 1.20047 19.0552 2.06485 19.0552L2.06485 19.0553ZM15.5048 12.9118C15.6492 12.8162 16.2727 12.9596 16.7527 12.7674C16.9927 12.6718 17.1848 12.4796 17.377 12.2874C17.4727 12.1918 17.6648 11.9996 17.7127 11.9996C17.7605 11.9996 17.9527 12.1918 18.0483 12.2874C18.4805 12.7674 18.7205 12.863 19.3927 12.863C19.4405 12.863 19.8248 12.863 19.9205 12.9108C19.9683 12.9586 19.9683 13.1986 19.9683 13.343C19.9683 14.063 20.0639 14.303 20.5439 14.783C20.6395 14.8787 20.8317 15.0708 20.8317 15.1186C20.8317 15.1665 20.6395 15.3586 20.5439 15.4543C20.3517 15.6464 20.1595 15.8386 20.0639 16.0786C19.8717 16.5586 20.0161 17.183 19.9195 17.3264C19.8239 17.4221 19.1039 17.2786 18.6717 17.4708C18.3361 17.6152 18.1439 17.903 17.9039 18.0952H17.5195C17.2795 17.8552 17.0395 17.6152 16.7517 17.4708C16.3673 17.3265 15.6473 17.3752 15.5039 17.3264C15.4561 17.2786 15.4561 17.0386 15.4561 16.8943C15.4561 16.1743 15.3605 15.9343 14.8805 15.4543C14.7848 15.3586 14.5927 15.1664 14.5927 15.1186C14.5927 15.0708 14.7849 14.8786 14.8805 14.783C15.3605 14.303 15.4561 14.1108 15.4561 13.343C15.5048 13.1996 15.5048 12.9596 15.5048 12.9118L15.5048 12.9118ZM17.9048 20.6395C17.8092 20.5917 17.6648 20.5917 17.5692 20.6395L15.457 21.5039L16.5127 18.4794C16.8005 18.6716 17.1361 19.1994 17.7605 19.1994C18.3361 19.1994 18.6727 18.6716 19.0083 18.4316L20.0639 21.4561L17.9048 20.6395ZM1.44037 2.78402C1.44037 2.4484 1.72818 2.15964 2.06475 2.15964H21.9848C22.3204 2.15964 22.6091 2.44744 22.6091 2.78402V17.5195C22.6091 17.8552 22.3213 18.1439 21.9848 18.1439H20.5448C20.5926 18.0961 20.6404 18.0961 20.6404 18.0483C21.1204 17.5683 20.8804 16.8005 20.976 16.5127C21.1204 16.1283 22.6082 15.5049 21.2638 14.1127C21.1682 14.0171 21.0238 13.8727 20.976 13.8249C20.8316 13.4405 21.3604 11.9527 19.5838 11.9527C19.056 11.9527 19.1038 12.0005 18.7682 11.6649C18.0004 10.8971 17.4726 10.8493 16.7038 11.6649C16.3682 12.0005 16.416 11.9527 15.8882 11.9527C14.1126 11.9527 14.6404 13.4405 14.496 13.8249C14.3516 14.2093 12.8638 14.8805 14.2082 16.2249C14.5438 16.5127 14.496 16.5127 14.496 16.9449C14.496 17.4249 14.5438 17.8571 14.9282 18.1449L2.06467 18.1439C1.72905 18.1439 1.44028 17.8561 1.44028 17.5196L1.44037 2.78402Z"
                fill="#333333"
              />
              <path
                d="M4.56008 4.79984H18.8646C19.1524 4.79984 19.3446 4.60766 19.3446 4.31984C19.3446 4.03203 19.1524 3.83984 18.8646 3.83984H4.56008C4.27227 3.83984 4.08008 4.03203 4.08008 4.31984C4.08008 4.55984 4.32008 4.79984 4.56008 4.79984Z"
                fill="#212121"
              />
              <path
                d="M4.56008 7.39213H18.8646C19.1524 7.39213 19.3446 7.19994 19.3446 6.91213C19.3446 6.62432 19.1524 6.43213 18.8646 6.43213H4.56008C4.27227 6.43213 4.08008 6.62432 4.08008 6.91213C4.08008 7.15213 4.32008 7.39213 4.56008 7.39213Z"
                fill="#212121"
              />
              <path
                d="M4.56008 9.93559H18.8646C19.1524 9.93559 19.3446 9.7434 19.3446 9.45559C19.3446 9.16778 19.1524 8.97559 18.8646 8.97559H4.56008C4.27227 8.97559 4.08008 9.16777 4.08008 9.45559C4.08008 9.74433 4.32008 9.93559 4.56008 9.93559Z"
                fill="#212121"
              />
              <path
                d="M4.56008 13.8721H12.3356C12.6234 13.8721 12.8156 13.6799 12.8156 13.3921C12.8156 13.1043 12.6234 12.9121 12.3356 12.9121H4.56008C4.27227 12.9121 4.08008 13.1043 4.08008 13.3921C4.08008 13.6321 4.32008 13.8721 4.56008 13.8721Z"
                fill="#212121"
              />
              <path
                d="M4.56008 16.4644H9.64784C9.93565 16.4644 10.1278 16.2722 10.1278 15.9844C10.1278 15.6966 9.93565 15.5044 9.64784 15.5044H4.56008C4.27227 15.5044 4.08008 15.6966 4.08008 15.9844C4.08008 16.2244 4.32008 16.4644 4.56008 16.4644Z"
                fill="#212121"
              />
              <path
                d="M17.7608 17.0397C18.8164 17.0397 19.6808 16.1753 19.6808 15.1197C19.6808 14.0641 18.8164 13.1997 17.7608 13.1997C16.7052 13.1997 15.8408 14.0641 15.8408 15.1197C15.8408 16.1753 16.6564 17.0397 17.7608 17.0397ZM17.7608 14.1597C18.2886 14.1597 18.7208 14.5919 18.7208 15.1197C18.7208 15.6475 18.2886 16.0797 17.7608 16.0797C17.233 16.0797 16.8008 15.6475 16.8008 15.1197C16.8008 14.5919 17.233 14.1597 17.7608 14.1597Z"
                fill="#212121"
              />
            </svg>
            <p class="font-solusi text-sm text-[#383838] ml-2">
              Sertifikasi penyelesaian dan kelulusan
            </p>
          </div>
          <div class="flex items-center mb-3">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              class="w-5 h-5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9998 11.7781C13.1233 11.7781 14.1366 11.1015 14.5662 10.0633C14.9959 9.025 14.7584 7.83049 13.9639 7.03589C13.1693 6.24136 11.9748 6.00386 10.9365 6.43356C9.89901 6.86401 9.22168 7.87651 9.22168 8.99994C9.22168 9.73665 9.51464 10.4437 10.0357 10.964C10.5568 11.4851 11.2631 11.778 11.9998 11.778L11.9998 11.7781ZM11.9998 7.33353C12.6741 7.33353 13.2819 7.73977 13.5397 8.36242C13.7975 8.98508 13.6553 9.70225 13.1779 10.1788C12.7014 10.6554 11.985 10.7976 11.3623 10.5397C10.7389 10.2819 10.3335 9.67413 10.3335 8.99992C10.3335 8.0796 11.0795 7.33353 11.9998 7.33353Z"
                fill="#333333"
              />
              <path
                d="M21.4443 4H2.55546C2.24842 4 2 4.24922 2 4.55546V17.8889C2 18.0366 2.05859 18.178 2.1625 18.2819C2.26719 18.3858 2.4086 18.4444 2.55546 18.4444H21.4443C21.5912 18.4444 21.7326 18.3858 21.8373 18.2819C21.9412 18.178 21.9998 18.0366 21.9998 17.8889V4.55546C21.9998 4.40858 21.9412 4.26718 21.8373 4.16328C21.7326 4.05859 21.5912 4 21.4443 4V4ZM7.03902 17.3335C7.42184 16.3343 8.10385 15.4788 8.99212 14.8819C9.87962 14.285 10.9304 13.9772 11.9999 13.9999C13.3803 13.9897 14.7123 14.5085 15.7217 15.4499C16.274 15.9733 16.6967 16.6178 16.9553 17.3335L7.03902 17.3335ZM20.8889 17.3335H18.1107C18.1185 17.2804 18.1185 17.2257 18.1107 17.1726C17.799 16.2101 17.249 15.3421 16.5107 14.65C15.2897 13.5047 13.674 12.8734 11.9998 12.8891C10.6584 12.857 9.3412 13.2547 8.24121 14.0242C7.142 14.7937 6.31778 15.8953 5.88883 17.1672C5.88023 17.2219 5.88023 17.2781 5.88883 17.3336H3.11065V5.11188H20.8887L20.8889 17.3335Z"
                fill="#212121"
              />
              <path
                d="M17.555 19.5552H6.44413C6.13709 19.5552 5.88867 19.8044 5.88867 20.1114C5.88867 20.4176 6.13711 20.6669 6.44413 20.6669H17.555C17.8621 20.6669 18.1105 20.4176 18.1105 20.1114C18.1105 19.8044 17.8621 19.5552 17.555 19.5552Z"
                fill="#212121"
              />
            </svg>
            <p class="font-solusi text-sm text-[#383838] ml-2">
              Webinar pelatihan dengan mentor
            </p>
          </div> -->
          <button
            @click="showModalShare = true"
            class="w-full rounded-full py-2 bg-white border border-[#E0E0E0] text-[#212121] font-solusi text-base font-semibold mb-3 outline-none focus:outline-none flex justify-center items-center my-5"
          >
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              class="mr-2 w-5 h-5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.5 16.08C17.74 16.08 17.06 16.38 16.54 16.85L9.41 12.7C9.46 12.47 9.5 12.24 9.5 12C9.5 11.76 9.46 11.53 9.41 11.3L16.46 7.19C17 7.69 17.71 8 18.5 8C20.16 8 21.5 6.66 21.5 5C21.5 3.34 20.16 2 18.5 2C16.84 2 15.5 3.34 15.5 5C15.5 5.24 15.54 5.47 15.59 5.7L8.54 9.81C8 9.31 7.29 9 6.5 9C4.84 9 3.5 10.34 3.5 12C3.5 13.66 4.84 15 6.5 15C7.29 15 8 14.69 8.54 14.19L15.66 18.35C15.61 18.56 15.58 18.78 15.58 19C15.58 20.61 16.89 21.92 18.5 21.92C20.11 21.92 21.42 20.61 21.42 19C21.42 17.39 20.11 16.08 18.5 16.08Z"
                fill="#212121"
              />
            </svg>
            Bagikan
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="recommendations?.length > 0"
      class="max-w-6xl mx-auto rounded-none md:rounded-md"
    >
      <div class="flex items-center justify-between p-3">
        <p class="font-desain text-[#383838] font-semibold text-2xl">
          Rekomendasi Kelas Lainnya
        </p>
      </div>
      <div class="px-3 pb-3">
        <carousel
          snapAlign="start"
          :settings="{
            itemsToShow: 1.5,
          }"
          :itemsToScroll="4"
          :breakpoints="{
            768: {
              itemsToShow: 4,
            },
          }"
        >
          <slide v-for="(classroom, i) in recommendations" :key="i">
            <div
              class="carousel__item p-2 m-2 rounded-md hover:bg-[#EEF2FF] duration-300 w-full shadow hover:shadow-md bg-[#FFFFFF]"
            >
              <div class="flex flex-col justify-between min-h-[19.5rem]">
                <img
                  @click="$router.push('/classroom/' + classroom.code)"
                  :src="classroom.thumbnail"
                  alt=""
                  class="rounded-t-md object-cover h-36 cursor-pointer"
                />
                <div
                  class="flex flex-col flex-grow justify-between my-2 relative"
                >
                  <router-link
                    :to="'/classroom/' + classroom.code"
                    v-tooltip="{
                      content: classroom.name,
                    }"
                    class=" text-sm font-solusi font-semibold text-[#383838] text-left line-clamp-2 overflow-hidden mb-2 cursor-pointer"
                  >
                    {{ classroom.name }}
                  </router-link>
                  <div
                    v-if="classroom?.mentor_data.length"
                    class="flex items-center w-full"
                  >
                    <img
                      :src="classroom?.mentor_data[0]?.photo"
                      alt=""
                      class="rounded-full h-10 w-10"
                    />
                    <div class="flex flex-col w-full ml-2 truncate">
                      <p
                        class="font-solusi text-xs text-[#212121] font-semibold text-left mb-1"
                      >
                        {{ classroom?.mentor_data[0]?.name }}
                      </p>
                      <p class="font-solusi text-2xs text-[#383838] text-left">
                        {{ classroom?.mentor_data[0]?.attribution }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="flex items-center my-2">
                  <div v-for="i in 5" :key="i" class="">
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      class="w-4 h-4"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.0489 2.92705C17.3483 2.00574 18.6517 2.00574 18.9511 2.92705L21.8167 11.7467C21.9506 12.1587 22.3346 12.4377 22.7678 12.4377H32.0413C33.0101 12.4377 33.4128 13.6773 32.6291 14.2467L25.1267 19.6976C24.7762 19.9522 24.6295 20.4036 24.7634 20.8156L27.6291 29.6353C27.9284 30.5566 26.874 31.3227 26.0902 30.7533L18.5878 25.3024C18.2373 25.0478 17.7627 25.0478 17.4122 25.3024L9.90976 30.7533C9.12605 31.3227 8.07157 30.5566 8.37092 29.6353L11.2366 20.8156C11.3705 20.4036 11.2238 19.9522 10.8733 19.6976L3.37088 14.2467C2.58717 13.6773 2.98994 12.4377 3.95867 12.4377H13.2322C13.6654 12.4377 14.0494 12.1587 14.1833 11.7467L17.0489 2.92705Z"
                        fill="#FFC200"
                      />
                    </svg>
                  </div>
                  <div class="ml-1 flex flex-grow items-center">
                    <span
                      class="font-solusi text-xs font-semibold text-[#212121] mx-1"
                      >{{ classroom?.rating }}</span
                    >
                    <span class="font-solusi text-xs font-normal text-[#9E9E9E]"
                      >({{ classroom?.rating_count }} Rating)</span
                    >
                  </div>
                </div>
                <div class="flex items-center">
                  <div class="font-desain text-xl font-semibold mr-1">
                    Rp. {{ classroom?.rupiah_price_formatted }}
                  </div>
                  <div
                    class="font-solusi text-[#DE1306] text-sm font-normal line-through"
                  >
                    Rp. {{ classroom?.normal_price_formatted }}
                  </div>
                </div>
              </div>
              <div v-if="!salesClosed" class="flex flex-col">
                <button
                  @click="addToCart(classroom?.code)"
                  class="w-full rounded-full text-white font-solusi text-xs text-center py-2 font-semibold mt-2"
                  :class="
                    isPreOrder(classroom?.started_at)
                      ? 'bg-[#FB8500]'
                      : 'bg-[#219EBC]'
                  "
                >
                  {{
                    isPreOrder(classroom?.started_at)
                      ? 'Pre-Order Sekarang'
                      : 'Beli Kelas'
                  }}
                </button>
              </div>
            </div>
          </slide>
          <template #addons="{ slidesCount, currentSlide }">
            <navigation
              v-if="recommendations?.length > 4"
              :class="{
                'is-first-slide': !currentSlide,
                'is-last-slide': currentSlide === slidesCount - 1,
              }"
            />
          </template>
        </carousel>
      </div>
    </div>

    <!-- Popup Video -->
    <transition name="fade">
      <div
        v-if="showModalVideo"
        class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated zoomIn"
      leave-active-class="animated zoomOut"
    >
      <div
        v-if="showModalVideo"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-51 backdrop-blur-sm"
      >
        <div class="relative w-full md:w-1/2 my-auto md:my-6 mx-2 md:mx-auto">
          <div
            v-click-away="closeVideo"
            class="bg-[#1c1d1f] border-0 shadow-lg relative flex flex-col w-full outline-none focus:outline-none max-h-[65vh]"
          >
            <div class="flex items-center justify-between px-5 py-3">
              <div class="flex items-center">
                <p class="font-desain text-lg text-white font-semibold">
                  {{ classroom?.name }}
                </p>
              </div>
              <div
                class="modal-close cursor-pointer hover:bg-gray-700 rounded-sm p-1 duration-500"
                @click="closeVideo()"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.6451 4.36708C19.1718 3.89382 18.4073 3.89382 17.934 4.36708L12 10.289L6.06598 4.35495C5.59272 3.88168 4.82821 3.88168 4.35495 4.35495C3.88168 4.82821 3.88168 5.59272 4.35495 6.06598L10.289 12L4.35495 17.934C3.88168 18.4073 3.88168 19.1718 4.35495 19.6451C4.82821 20.1183 5.59272 20.1183 6.06598 19.6451L12 13.711L17.934 19.6451C18.4073   20.1183 19.1718 20.1183 19.6451 19.6451C20.1183 19.1718 20.1183 18.4073 19.6451 17.934L13.711 12L19.6451 6.06598C20.1062 5.60485 20.1062 4.82821 19.6451 4.36708Z"
                    fill="#FFFFFF"
                  />
                </svg>
              </div>
            </div>
            <div class="w-full h-full px-3 pb-3">
              <vue-plyr
                v-show="isIframe"
                id="vplyr"
                class="w-full"
                :clickToPlay="true"
                :options="{
                  controls: [
                    'play-large',
                    'play',
                    'progress',
                    'current-time',
                    'mute',
                    'volume',
                    'fullscreen',
                  ],
                  disableContextMenu: false,
                }"
              >
                <div class="plyr__video-embed">
                  <iframe
                    :src="linkIframe"
                    allowfullscreen
                    allowtransparency
                    allow="autoplay"
                  ></iframe>
                </div>
              </vue-plyr>
              <vue-plyr
                v-show="!isIframe"
                id="vplyr"
                class="w-full"
                :clickToPlay="true"
                :options="{
                  controls: [
                    'play-large',
                    'play',
                    'progress',
                    'current-time',
                    'mute',
                    'volume',
                    'fullscreen',
                  ],
                }"
              >
                <video playsinline>
                  <source :src="classroom?.url_video" type="video/mp4" />
                  dont support
                </video>
              </vue-plyr>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Popup Add To Cart -->
    <transition name="fade">
      <div
        v-if="showModalAddToCart"
        class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated zoomIn"
      leave-active-class="animated zoomOut"
    >
      <div
        v-if="showModalAddToCart"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-51 backdrop-blur-sm"
      >
        <div class="relative w-full md:w-1/3 my-auto md:my-6 mx-2 md:mx-auto">
          <div
            v-click-away="closeModalAddToCart"
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none divide-y divide-gray-200 max-h-[65vh]"
          >
            <div class="flex items-center justify-between px-5 py-3 rounded-t">
              <div class="flex items-center">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  class="mr-2"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="12" fill="#2FA742" />
                  <path
                    d="M9.27366 17.9117C9.54836 18.1935 9.93059 18.3532 10.3301 18.3532C10.3339 18.3532 10.338 18.3532 10.3423 18.3532C10.7464 18.3498 11.1307 18.1838 11.4033 17.8943L19.3842 9.41787C19.9253 8.84321 19.8833 7.95201 19.2909 7.42732C18.6983 6.903 17.7792 6.94339 17.2381 7.51786L10.312 14.8737L8.15605 12.6598C7.60471 12.0939 6.68489 12.0687 6.10178 12.6028C5.51827 13.1371 5.49231 14.0287 6.04308 14.5945L9.27366 17.9117Z"
                    fill="white"
                  />
                </svg>
                <p class="font-desain text-lg text-[#212121] font-semibold">
                  Berhasil ditambahkan ke keranjang
                </p>
              </div>
              <div
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
                @click="closeModalAddToCart()"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.6451 4.36708C19.1718 3.89382 18.4073 3.89382 17.934 4.36708L12 10.289L6.06598 4.35495C5.59272 3.88168 4.82821 3.88168 4.35495 4.35495C3.88168 4.82821 3.88168 5.59272 4.35495 6.06598L10.289 12L4.35495 17.934C3.88168 18.4073 3.88168 19.1718 4.35495 19.6451C4.82821 20.1183 5.59272 20.1183 6.06598 19.6451L12 13.711L17.934 19.6451C18.4073 20.1183 19.1718 20.1183 19.6451 19.6451C20.1183 19.1718 20.1183 18.4073 19.6451 17.934L13.711 12L19.6451 6.06598C20.1062 5.60485 20.1062 4.82821 19.6451 4.36708Z"
                    fill="#212121"
                  />
                </svg>
              </div>
            </div>
            <div class="overflow-y-auto divide-y divide-gray-200 scroll-custom">
              <div
                v-for="(cart, i) in getCartData"
                :key="i"
                class="px-6 py-4 hover:bg-gray-100 duration-300"
              >
                <div class="grid grid-cols-4 gap-2">
                  <div class="col-span-3 flex items-center">
                    <img
                      :src="cart.thumbnail"
                      alt=""
                      class="object-cover rounded-md h-20 w-20"
                    />
                    <div
                      class="ml-2 flex-grow flex flex-col justify-start h-20 relative"
                    >
                      <router-link
                        :to="'/classroom/' + cart.code"
                        class="font-solusi text-sm text-[#383838] line-clamp-3 font-semibold hover:text-[#0A72ED] mb-1 overflow-hidden"
                      >
                        {{ cart.name }}
                      </router-link>
                      <p class="font-solusi text-xs text-[#757575] font-medium">
                        Oleh Brian Christiansen
                      </p>
                    </div>
                  </div>
                  <div class="col-span-1">
                    <p
                      class="font-solusi text-sm text-[#383838] text-right font-semibold"
                    >
                      Rp. {{ cart.price_formatted }}
                    </p>
                    <p
                      v-if="cart.normal_price_formatted"
                      class="font-solusi text-xs text-[#DE1306] text-right font-medium line-through"
                    >
                      Rp. {{ cart.normal_price_formatted }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-col">
              <div class="flex justify-between items-center px-5 py-3">
                <p class="font-desain text-lg text-[#383838] font-semibold">
                  Total Harga
                </p>
                <p class="font-desain text-lg textblack-60 font-semibold">
                  Rp. {{ cartTotalPriceFormat() }}
                </p>
              </div>
              <div class="grid grid-cols-2 gap-6 px-5 mb-6">
                <router-link
                  to="/cart"
                  class="text-center bg-white rounded-full border-2 border-[#00446F] text-[#00446F] py-2 font-solusi font-semibold"
                >
                  Lihat Keranjang
                </router-link>
                <router-link
                  to="/cart?next=buy-now"
                  class="text-center bg-[#00446F] rounded-full border-2 border-[#00446F] text-white py-2 font-solusi font-semibold"
                >
                  Lanjut Bayar
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Popup Share -->
    <transition name="fade">
      <div
        v-if="showModalShare"
        class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        v-if="showModalShare"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-51 backdrop-blur-sm"
      >
        <div class="relative w-full md:w-1/3 my-auto md:my-6 mx-2 md:mx-auto">
          <div
            v-click-away="closeModalShare"
            class="rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[80vh]"
          >
            <div class="flex items-center justify-end px-5 py-3 rounded-t">
              <div
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
                @click="closeModalShare()"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.6451 4.36708C19.1718 3.89382 18.4073 3.89382 17.934 4.36708L12 10.289L6.06598 4.35495C5.59272 3.88168 4.82821 3.88168 4.35495 4.35495C3.88168 4.82821 3.88168 5.59272 4.35495 6.06598L10.289 12L4.35495 17.934C3.88168 18.4073 3.88168 19.1718 4.35495 19.6451C4.82821 20.1183 5.59272 20.1183 6.06598 19.6451L12 13.711L17.934 19.6451C18.4073 20.1183 19.1718 20.1183 19.6451 19.6451C20.1183 19.1718 20.1183 18.4073 19.6451 17.934L13.711 12L19.6451 6.06598C20.1062 5.60485 20.1062 4.82821 19.6451 4.36708Z"
                    fill="#212121"
                  />
                </svg>
              </div>
            </div>
            <div class="overflow-y-auto scroll-custom">
              <div class="pb-10 px-5 md:px-10">
                <p
                  class="text-center font-desain font-semibold text-xl text-[#212121] mb-5"
                >
                  Bagikan
                </p>
                <div class="grid grid-cols-4 gap-2">
                  <a
                    :href="'https://api.whatsapp.com/send?text=' + getUrl"
                    class="col-span-1 flex flex-col items-center justify-start text-[#212121] hover:text-[#0A72ED] mb-2 cursor-pointer"
                    target="_blank"
                    data-action="share/whatsapp/share"
                  >
                    <img
                      src="/assets/images/icon/whatsapp.png"
                      alt=""
                      class="rounded-full bg-[#F5F7FD] p-2 w-12 h-12"
                    />
                    <div class="font-solusi text-xs mt-1 text-center">
                      Whatsapp
                    </div>
                  </a>
                  <a
                    :href="'https://telegram.me/share/url?url=' + getUrl"
                    class="col-span-1 flex flex-col items-center justify-start text-[#212121] hover:text-[#0A72ED] mb-2 cursor-pointer"
                    target="_blank"
                  >
                    <img
                      src="/assets/images/icon/telegram.png"
                      alt=""
                      class="rounded-full bg-[#F5F7FD] p-2 w-12 h-12"
                    />
                    <div class="font-solusi text-xs mt-1 text-center">
                      Telegram
                    </div>
                  </a>
                  <a
                    :href="
                      'https://www.linkedin.com/shareArticle?url=' + getUrl
                    "
                    class="col-span-1 flex flex-col items-center justify-start text-[#212121] hover:text-[#0A72ED] mb-2 cursor-pointer"
                    target="_blank"
                  >
                    <img
                      src="/assets/images/icon/linkedin.png"
                      alt=""
                      class="rounded-full bg-[#F5F7FD] p-2 w-12 h-12"
                    />
                    <div class="font-solusi text-xs mt-1 text-center">
                      Linkedin
                    </div>
                  </a>
                  <a
                    :href="
                      'https://www.facebook.com/sharer/sharer.php?u=' + getUrl
                    "
                    class="col-span-1 flex flex-col items-center justify-start text-[#212121] hover:text-[#0A72ED] mb-2 cursor-pointer"
                    target="_blank"
                  >
                    <img
                      src="/assets/images/icon/facebook.png"
                      alt=""
                      class="rounded-full bg-[#F5F7FD] p-2 w-12 h-12"
                    />
                    <div class="font-solusi text-xs mt-1 text-center">
                      Facebook
                    </div>
                  </a>
                  <a
                    :href="'https://www.instagram.com/?url=' + getUrl"
                    class="col-span-1 flex flex-col items-center justify-start text-[#212121] hover:text-[#0A72ED] mb-2 cursor-pointer"
                    target="_blank"
                  >
                    <img
                      src="/assets/images/icon/instagram.png"
                      alt=""
                      class="rounded-full bg-[#F5F7FD] p-2 w-12 h-12"
                    />
                    <div class="font-solusi text-xs mt-1 text-center">
                      Instagram
                    </div>
                  </a>
                  <a
                    :href="'https://twitter.com/share?url=' + getUrl"
                    class="col-span-1 flex flex-col items-center justify-start text-[#212121] hover:text-[#0A72ED] mb-2 cursor-pointer"
                    target="_blank"
                  >
                    <img
                      src="/assets/images/icon/twitter.png"
                      alt=""
                      class="rounded-full bg-[#F5F7FD] p-2 w-12 h-12"
                    />
                    <div class="font-solusi text-xs mt-1 text-center">
                      Twitter
                    </div>
                  </a>
                  <a
                    :href="'mailto:?body=' + getUrl"
                    target="_blank"
                    class="col-span-1 flex flex-col items-center justify-start text-[#212121] hover:text-[#0A72ED] mb-2 cursor-pointer"
                  >
                    <img
                      src="/assets/images/icon/gmail.png"
                      alt=""
                      class="rounded-full bg-[#F5F7FD] px-2 py-3.5 w-12"
                    />
                    <div class="font-solusi text-xs mt-1 text-center">
                      Mail
                    </div>
                  </a>
                  <a
                    @click="copyLink()"
                    class="col-span-1 flex flex-col items-center justify-start text-[#212121] hover:text-[#0A72ED] mb-2 cursor-pointer"
                  >
                    <input type="hidden" ref="link" :value="getUrl" />
                    <img
                      src="/assets/images/icon/link.png"
                      alt=""
                      class="rounded-full bg-[#F5F7FD] p-2 w-12 h-12"
                    />
                    <div class="font-solusi text-xs mt-1 text-center">
                      Salin Link
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Popup Voucher -->
    <transition name="fade">
      <div
        v-if="showModalVoucher"
        class="opacity-50 fixed inset-0 z-51 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        v-if="showModalVoucher"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-51"
      >
        <div class="relative w-full md:w-1/3 my-6 mx-4 md:mx-auto">
          <div
            v-click-away="closeModalVoucher"
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[80vh]"
          >
            <div class="flex items-start justify-end px-3 pt-3 rounded-t">
              <div
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
                @click="closeModalVoucher()"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.6451 4.36708C19.1718 3.89382 18.4073 3.89382 17.934 4.36708L12 10.289L6.06598 4.35495C5.59272 3.88168 4.82821 3.88168 4.35495 4.35495C3.88168 4.82821 3.88168 5.59272 4.35495 6.06598L10.289 12L4.35495 17.934C3.88168 18.4073 3.88168 19.1718 4.35495 19.6451C4.82821 20.1183 5.59272 20.1183 6.06598 19.6451L12 13.711L17.934 19.6451C18.4073 20.1183 19.1718 20.1183 19.6451 19.6451C20.1183 19.1718 20.1183 18.4073 19.6451 17.934L13.711 12L19.6451 6.06598C20.1062 5.60485 20.1062 4.82821 19.6451 4.36708Z"
                    fill="#212121"
                  />
                </svg>
              </div>
            </div>
            <div class="pb-6 px-6 flex-auto overflow-x-hiden overflow-y-auto">
              <img
                :src="
                  redeemStatus
                    ? '/assets/images/modal/voucher-success.svg'
                    : '/assets/images/modal/voucher-failed.svg'
                "
                alt=""
                class="w-36 md:w-40 m-auto"
              />
              <p
                class="font-desain text-[#212121] text-lg text-center my-2 font-semibold"
              >
                {{ redeemStatus ? 'Berhasil' : 'Gagal' }} Menukarkan Voucher
              </p>
              <p
                v-if="redeemStatus"
                class="font-solusi text-[#212121] text-sm text-center mb-4"
              >
                {{ voucherDetail }}
              </p>
              <p
                v-else
                class="font-solusi text-[#212121] text-sm text-center mb-4"
              >
                Sayang sekali, kode voucher yang kamu masukkan tidak valid,
                tukarkan voucher lainnya!
              </p>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <ImageRating
      :show="showImageRating"
      :image="selectedImageRating"
      :close="closeImageRating"
    />
  </div>
</template>

<script lang="ts">
/* eslint-disable */
import { defineComponent } from 'vue'
import Auth from '@/utils/Auth'
import { ClassroomDetail, Cart } from '@/dto'
import ClassroomModel from '@/models/ClassroomModel'
import CartModel from '@/models/CartModel'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import { useToast } from 'vue-toastification'
import VoucherClassroomModel from '@/models/VoucherClassroomModel'
import moment from 'moment'
import ImageRating from '@/main/components/Cards/ImageRating.vue'
import { salesClosed } from '@/utils/ServiceAvailability'

export default defineComponent({
  name: 'Detail Classroom',
  setup() {
    const toast = useToast()
    return {
      Auth,
      toast,
    }
  },
  components: {
    Carousel,
    Slide,
    Navigation,
    ImageRating,
  },
  data() {
    return {
      salesClosed,
      code: this.$route.params.code as string,
      classroom: {} as ClassroomDetail,
      showDescription: false,
      showMentor: false,
      showModalAddToCart: false,
      loadingAddToCart: false,
      showModalShare: false,
      carts: [] as Cart[],
      recommendations: [] as any,
      loadingRecommendation: false,
      openMaterials: [] as any,
      totalMaterial: 0 as number,
      reviews: [] as any,
      reviewPage: {
        page: 1,
        from: 1,
        total: 0,
        perPage: 10,
      },
      reviewRating: {} as any,
      openMaterial: [1] as any,
      openExam: false,
      showModalVideo: false,
      isIframe: false,
      linkIframe: '' as string,
      checkout: this.$route.query.checkout,
      voucher: '' as string,
      showModalVoucher: false,
      redeemStatus: false,
      loadingVoucher: false,
      voucherDetail: '' as any,

      showImageRating: false as Boolean,
      selectedImageRating: '' as string,
    }
  },
  async created() {
    await this.getClassroomDetail()
  },
  mounted() {
    this.getClassroomRecommendation()
    this.getClassroomReview()
  },
  computed: {
    getCartLoading(): boolean {
      return this.$store.getters['cartStore/getCartLoading']
    },
    getCartData(): Array<any> {
      return this.$store.getters['cartStore/getCartData']
    },
    isExistOnCart(): boolean {
      if (this.$store.getters['cartStore/getCartData'].length > 0) {
        return this.$store.getters['cartStore/getCartData'].some(
          (el: any) => el.code == this.code
        )
      } else {
        return false
      }
    },
    getUrl() {
      return window.location.href 
    },
  },
  methods: {
    isOpenMaterial(id: number) {
      return this.openMaterial.some((el: number) => el == id)
    },
    toggleMaterial(id: number) {
      if(this.openMaterials.some((el: number) => el == id)) {
        this.openMaterials.filter((el: number) => { return el != id})
      } else {
        this.openMaterials.push(id)
      }
    },
    reRender() {
      this.code = this.$route.params.code as string
      this.getClassroomDetail()
      this.getClassroomRecommendation()
      this.getClassroomReview()
    },
    toggle(id: number) {
      this.classroom.material.forEach((el: any, i: number) => {
        if(el.id == id) {
          if(el.active) {
            this.classroom.material[i].active =  false
          } else {
            this.classroom.material[i].active =  true
          }
        }
      })
    },
    async getClassroomDetail() {
      if(Auth.isLoggedIn()) {
        await ClassroomModel.detailPrivateV2(this.code)
          .then(res => {
            if (res.success) {
              if (!salesClosed && this.checkout != 'true' && res.data.landing_page.includes('https://')) {
                window.location.href = res.data.landing_page
              } else {
                this.classroom = res.data
                if(this.classroom.material.length) {
                  let countMaterial = 0
                  this.classroom.material.forEach((el: any, i: number) => {
                    countMaterial += el.material.length
                    if(i == 0) {
                      this.classroom.material[i].active = true
                    } else {
                      this.classroom.material[i].active = false
                    }
                  })
                  this.totalMaterial = countMaterial
                }
                if (!salesClosed && !res.data?.must_voucher) {
                  this.addToCart(this.code)
                }
              }
            } else {
              this.$router.push('/')
            }
          })
          .catch(err => {
            this.$router.push('/')
          })
      } else {
        if (!salesClosed && this.checkout) {
          this.$router.push('/register?redirect=/classroom/' + this.code + '?checkout=true')
        } else {
          await ClassroomModel.detailPublicV2(this.code)
            .then(res => {
              if (res.success) {
                if (!salesClosed && res.data.landing_page.includes('https://')) {
                  window.location.href = res.data.landing_page
                } else {
                  this.classroom = res.data
                  if(this.classroom.material.length) {
                    let countMaterial = 0
                    this.classroom.material.forEach((el: any, i: number) => {
                      countMaterial += el.material.length
                      if(i == 0) {
                        this.classroom.material[i].active = true
                      } else {
                        this.classroom.material[i].active = false
                      }
                    })
                    this.totalMaterial = countMaterial
                  }
                }
              } else {
                this.$router.push('/')
              }
            })
            .catch(err => {
              this.$router.push('/')
            })
        }
      }

      if (this.classroom?.url_video?.includes('iframe')) {
        var parser: any = new DOMParser()
        var parsedIframe = parser.parseFromString(this.classroom?.url_video, "text/html");
        let iFrame = parsedIframe.getElementsByTagName("iframe");
        this.linkIframe = iFrame[0].src
        this.isIframe = true
      } else {
        this.isIframe = false
      }
    },
    async getCart() {
      await this.$store.dispatch('cartStore/fetchCart')
    },
    async buyNow() {
      if (salesClosed) { this.$router.push('/informasi-layanan'); return }
      if (Auth.isLoggedIn()) {
        await CartModel.addSingle(this.code)
          .then(async res => {
            if (res.success) {
              await this.getCart()
              this.$router.push('/cart?next=buy-now&course=' + this.code)
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        this.$router.push('/register?redirect=/classroom/' + this.code)
      }
    },
    async addToCart(code: string) {
      if (salesClosed) { this.$router.push('/informasi-layanan'); return }
      if (Auth.isLoggedIn()) {
        await CartModel.addSingle(code)
          .then(async res => {
            if (res.success) {
              await this.getCart()
              this.showModalAddToCart = true
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        if (this.checkout) {
          this.$router.push('/register?redirect=/classroom/' + code + '?checkout=true')
        } else {
          this.$router.push('/register?redirect=/classroom/' + code)
        }
      }
    },
    closeModalAddToCart() {
      this.showModalAddToCart = false
    },
    cartTotalPriceFormat() {
      let sum = 0
      this.getCartData.forEach((el: any) => {
        sum += el.price
      })

      return sum.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    },
    toggleDescription() {
      this.showDescription = !this.showDescription
    },
    toggleMentor() {
      if (this.classroom?.mentor[0]?.description != '') {
        this.showMentor = !this.showMentor
      }
    },
    async getClassroomRecommendation() {
      this.loadingRecommendation = true
      await ClassroomModel.recommendationPublic(this.code)
        .then(res => {
          this.loadingRecommendation = false
          // console.log(res)
          if (res.success) {
            this.recommendations = res.data
            // console.log(this.recommendations[0])
          }
        })
        .catch(err => {
          console.log(err)
          this.loadingRecommendation = false
        })
    },

    timeZone(date: string) {
      const dt = new Date(date)
      const offset = new Date().getTimezoneOffset()
      const timeZoneOffset = offset / 60

      switch (timeZoneOffset) {
        case -8:
          dt.setHours(dt.getHours() + 1)
          break
        case -9:
          dt.setHours(dt.getHours() + 2)
          break
        default:
          break
      }
      return moment(dt).format('YYYY-MM-DD HH:mm:ss')
    },
    
    isPreOrder(date: string) {
      const now = moment().format('YYYY-MM-DD HH:mm:ss')
      if (now > this.timeZone(date)) {
        return false
      } else {
        return true
      }
    },

    priceFormatted(price: number) {
      return price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    },

    closeModalShare() {
      this.showModalShare = false
    },

    copyLink() {
      let url = this.$refs.link as HTMLInputElement;
      try {
        url.setAttribute('type', 'text')
        url.select()
        document.execCommand("copy")
        this.toast.success('Berhasil disalin')
      } catch (err) {
        this.toast.success('Oops, unable to copy')
      }
      url.setAttribute('type', 'hidden')
    },

    changePageReview(event: any) {
      if(this.reviewPage.page != (event.page + 1)) {
        this.reviewPage.page = event.page + 1
        this.getClassroomReview()
      }
    },
    async getClassroomReview() {
      await ClassroomModel.classroomReview(this.code, this.reviewPage.page, this.reviewPage.perPage)
        .then(res => {
          this.reviews = res.data
          this.reviewRating = res.rating
          this.reviewPage.page = res.pages.current_page
          this.reviewPage.total = res.pages.total
          this.reviewPage.from = res.pages.from 
        })
        .catch(err => {
          console.log(err)
        })
    },
    getInitialName(name: string) {
      let initials:any = name.split(' ');
  
      if(initials.length > 1) {
        initials = initials.shift().charAt(0) + initials.pop().charAt(0);
      } else {
        initials = name.substring(0, 1);
      }
      return initials.toUpperCase();
    },
    toHex(name: string) {
      if (name) {
        var hash = 0;
        if (name.length === 0) return hash;
        for (var i = 0; i < name.length; i++) {
          hash = name.charCodeAt(i) + ((hash << 5) - hash);
          hash = hash & hash;
        }
        var color = '#';
        for (var i = 0; i < 3; i++) {
          var value = (hash >> (i * 8)) & 255;
          color += ('00' + value.toString(16)).substr(-2);
        }
        return color;
      } else {
        return '#52525b'
      }
    },
    openVideo() {
      this.showModalVideo = true
    },
    closeVideo() {
      this.showModalVideo = false
    },

    closeModalVoucher() {
      this.showModalVoucher = false
      this.voucher = ''
      this.voucherDetail = null
    },
    async redeemVoucher() {
      if (Auth.isLoggedIn()) {
        if (this.voucher) {
          this.loadingVoucher = true
          try {
            const { message, success } = await VoucherClassroomModel.redeem(
              this.voucher
            )
            if (success) {
              this.getClassroomDetail()
              this.voucherDetail = message
              this.loadingVoucher = false
              this.redeemStatus = true
              this.showModalVoucher = true
            } else {
              this.loadingVoucher = false
              this.redeemStatus = false
              this.showModalVoucher = true
            }
          } catch (err) {
            const error: any = (err as any).response.data.errors[0].message
            console.log(error)
            this.loadingVoucher = false
            this.redeemStatus = false
            this.showModalVoucher = true
          }
        }
      } else {
        this.$router.push('/register?q=daftar')
      }
    },

    openImageRating(url: string) {
      this.showImageRating = true
      this.selectedImageRating = url
    },

    closeImageRating() {
      this.showImageRating = false
      this.selectedImageRating = ''
    },
  },
  watch: {
    $route(to, from) {
      if (this.$route.params.code) {
        if (String(this.$route.params.code) != this.code) {
          this.reRender()
        }
      }
    },
  },
})
</script>

<style scoped>
::v-deep(.carousel__prev.is-first-slide) {
  display: none;
}
::v-deep(.carousel__next.is-last-slide) {
  display: none;
}
::v-deep(.carousel__next) {
  background-color: #ffffff !important;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
  color: #009dff !important;
}
::v-deep(.carousel__prev) {
  background-color: #ffffff !important;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
  color: #009dff !important;
}
@media (max-width: 768px) {
  ::v-deep(.carousel__next) {
    display: none;
  }
  ::v-deep(.carousel__prev) {
    display: none;
  }
}

.slide-enter-active,
.slide-leave-active {
  -moz-transition:  all 0.5s ease-in-out;
  -webkit-transition:  all 0.5s ease-in-out;
  -o-transition:  all 0.5s ease-in-out;
  transition:  all 0.5s ease-in-out;
}

.slide-enter-to, 
.slide-leave-from {
  height: auto;
  overflow: hidden;
}

.slide-enter-from, 
.slide-leave-to {
  height: 0;
  overflow: hidden;
}

.collapse-enter-active,
.collapse-leave-active {
  transition: max-height 0.5s ease-in-out;
  max-height: 100vh;
  overflow: hidden;
}
.collapse-enter-from,
.collapse-leave-to {
  max-height: 0px;
  overflow: hidden;
}

::v-deep(.p-column-title) {
  font-family: 'SolusiSans';
  font-weight: 700;
}
::v-deep(.p-paginator-current) {
  font-family: 'SolusiSans';
  font-weight: 600;
}
::v-deep(.p-paginator) {
  justify-content: flex-end;
  padding: 0;
}
::v-deep(.p-paginator .p-paginator-pages .p-paginator-page) {
  font-family: 'SolusiSans';
  font-weight: 500;
}
::v-deep(.p-paginator .p-paginator-pages .p-paginator-page.p-highlight) {
  border: 1px solid #009dff;
  color: #009dff;
  font-weight: 600;
  background-color: #fff;
}
</style>
